// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { Offcanvas, Form, Button, Row, Col, Card } from "react-bootstrap";

// const DirectOrderForm = ({ showModal, handleClose, fetchOrders }) => {
//   const [clients, setClients] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [formData, setFormData] = useState({
//     name: "",
//     client_id: "",
//     project_id: "",
//     products: [],
//     stage: "order",
//     is_direct_order: true,
//     subscription_start_date: "",
//     subscription_due_date: "",
//     vendor_subscription_end_dates: "",
//     payment_term: "",
//     deployment_start_date: "",
//     deployment_end_date: "",
//     order_date: new Date().toISOString().split("T")[0], // Set to today's date
//   });

//   useEffect(() => {
//     if (formData.vendor_subscription_end_dates) {
//       const endDate = new Date(formData.vendor_subscription_end_dates);
//       const dueDate = new Date(endDate);
//       dueDate.setDate(endDate.getDate() - 30); // subtract 30 days

//       // format to YYYY-MM-DD for input[type="date"]
//       const formattedDueDate = dueDate.toISOString().split("T")[0];

//       setFormData((prev) => ({
//         ...prev,
//         subscription_due_date: formattedDueDate,
//       }));
//     }
//   }, [formData.vendor_subscription_end_dates]);


//   // Fetch clients
//   const fetchClients = async () => {
//     try {
//       const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//       const origin = localStorage.getItem("user-origin");
//       const res = await axios.get(
//         `${process.env.REACT_APP_BACKEND_URL}/api/contacts?type=client`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Tenant-Origin": origin
//           },
//           skipLoader: true
//         }
//       );
//       setClients(res.data.Data);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const fetchProducts = async () => {
//     try {
//       const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//       const origin = localStorage.getItem("user-origin");
//       const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/products`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Tenant-Origin": origin
//         },
//         skipLoader: true
//       });
//       setProducts(res.data.Data);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (showModal) {
//       // ✅ Reset form every time modal opens
//       setFormData({
//         name: "",
//         client_id: "",
//         project_id: "",
//         products: [],
//         stage: "order",
//         is_direct_order: true,
//         subscription_start_date: "",
//         subscription_due_date: "",
//         vendor_subscription_end_dates: "",
//         payment_term: "",
//         deployment_start_date: "",
//         deployment_end_date: "",
//         order_date: new Date().toISOString().split("T")[0], // Set to today's date
//       });

//       fetchClients();
//       fetchProducts();
//     }
//   }, [showModal]);

//   // Handle general input changes
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   // Handle product row changes
//   // const handleProductChange = (index, field, value) => {
//   //   const newProducts = [...formData.products];
//   //   newProducts[index][field] = value;

//   //   // When product is selected, populate name, price, revenue type
//   //   if (field === "product_id") {
//   //     const selectedProduct = products.find((p) => p.id === parseInt(value));
//   //     if (selectedProduct) {
//   //       newProducts[index] = {
//   //         ...newProducts[index],
//   //         product_id: selectedProduct.id,
//   //         item_name: selectedProduct.product_name || "",
//   //         revenue_type: selectedProduct.revenue_type || "deferred",
//   //         price: selectedProduct.pricings.price || 0,
//   //         quantity: 1,
//   //         subscription_start: "",
//   //         subscription_end: "",
//   //         payment_term: "",
//   //       };
//   //     }
//   //   }

//   //   setFormData((prev) => ({ ...prev, products: newProducts }));
//   // };
//   // Handle product row changes
//   const handleProductChange = (index, field, value) => {
//     const newProducts = [...formData.products];
//     newProducts[index][field] = value;

//     // When product is selected, populate name, price, deployment cost based on revenue type
//     if (field === "product_id") {
//       const selectedProduct = products.find((p) => p.id === parseInt(value));
//       if (selectedProduct) {
//         // Get the pricing based on revenue type (license model)
//         const pricings = selectedProduct.pricings || [];

//         // Default to subscription pricing if available, otherwise use first pricing
//         let selectedPricing = pricings.find(p => p.license_model === "subscription") ||
//           pricings.find(p => p.license_model === "perpetual") ||
//           pricings.find(p => p.license_model === "hybrid") ||
//           pricings[0];

//         const price = selectedPricing ? parseFloat(selectedPricing.price) : 0;
//         const deploymentCost = selectedPricing ? parseFloat(selectedPricing.deployment_cost) : 0;

//         newProducts[index] = {
//           ...newProducts[index],
//           product_id: selectedProduct.id,
//           item_name: selectedProduct.product_name || "",
//           revenue_type: selectedProduct.revenue_type || "deferred",
//           price: price,
//           deployment_cost: deploymentCost,
//           quantity: 1,
//           license_model: selectedPricing?.license_model || "subscription",
//           subscription_start: "",
//           subscription_end: "",
//           payment_term: "",
//         };
//       }
//     }

//     setFormData((prev) => ({ ...prev, products: newProducts }));
//   };
//   // Add new product row
//   const addProductRow = () => {
//     setFormData((prev) => ({
//       ...prev,
//       products: [
//         ...prev.products,
//         {
//           product_id: "",
//           item_name: "",
//           price: 0,
//           quantity: 1,
//           revenue_type: "deferred",
//           subscription_start: "",
//           subscription_end: "",
//           payment_term: "",
//         },
//       ],
//     }));
//   };

//   // Remove product row
//   const removeProductRow = (index) => {
//     const newProducts = [...formData.products];
//     newProducts.splice(index, 1);
//     setFormData((prev) => ({ ...prev, products: newProducts }));
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//       const origin = localStorage.getItem("user-origin");

//       const payload = {
//         ...formData,
//         products: formData.products.map((p) => ({
//           ...p,
//           price: p.price,
//         })),
//       };

//       await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/deals/order`, payload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Tenant-Origin": origin
//         },
//       });

//       Swal.fire("Success", "Direct order created successfully", "success");
//       fetchOrders();
//       handleClose();
//     } catch (error) {
//       console.error(error);
//       Swal.fire("Error", "Failed to create direct order", "error");
//     }
//   };

//   return (
//     <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: "700px" }}>
//       <Offcanvas.Header closeButton className="border-bottom bg-light">
//         <Offcanvas.Title className="fw-bold">Create Direct Order</Offcanvas.Title>
//       </Offcanvas.Header>

//       <Offcanvas.Body className="p-4">
//         <Form onSubmit={handleSubmit}>
//           {/* Basic Information Card */}
//           <Card className="mb-4 border-0 shadow-sm">
//             <Card.Header className="bg-white border-bottom-0 pb-2">
//               <h6 className="mb-0 fw-bold text-primary">Order Information</h6>
//             </Card.Header>
//             <Card.Body>
//               <Row className="g-3">
//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Label className="fw-semibold small">Date</Form.Label>
//                     <Form.Control
//                       type="date"
//                       name="order_date"
//                       value={formData.order_date}
//                       onChange={handleInputChange}
//                       required
//                       className="form-control form-feild"
//                     />
//                   </Form.Group>
//                 </Col>
//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Label className="fw-semibold small">Name</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleInputChange}
//                       required
//                       className="form-control form-feild"
//                       placeholder="Enter name"
//                     />
//                   </Form.Group>
//                 </Col>

//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Label className="fw-semibold small">Client</Form.Label>
//                     <Form.Select
//                       name="client_id"
//                       value={formData.client_id}
//                       onChange={handleInputChange}
//                       required
//                       className="form-control form-feild"
//                     >
//                       <option value="">Select Client</option>
//                       {clients.map((c) => (
//                         <option key={c.id} value={c.id}>
//                           {c.name}
//                         </option>
//                       ))}
//                     </Form.Select>
//                   </Form.Group>
//                 </Col>
//               </Row>
//             </Card.Body>
//           </Card>

//           {/* Products Card */}
//           <Card className="mb-4 border-0 shadow-sm">
//             <Card.Header className="bg-white border-bottom-0 pb-2 d-flex justify-content-between align-items-center">
//               <h6 className="mb-0 fw-bold text-primary">Products & Services</h6>
//               <Button
//                 variant="outline-primary"
//                 size="sm"
//                 onClick={addProductRow}
//                 className="px-3"
//               >
//                 + Add Product
//               </Button>
//             </Card.Header>
//             <Card.Body>
//               {formData.products.length === 0 ? (
//                 <div className="text-center py-4 text-muted">
//                   <p>No products added yet</p>
//                   <small>Click "Add Product" to get started</small>
//                 </div>
//               ) : (
//                 formData.products.map((product, index) => (
//                   <div key={index} className="product-card border rounded p-3 mb-3 bg-light">
//                     <div className="d-flex justify-content-between align-items-start mb-3">
//                       <h6 className="mb-0 fw-semibold">Product #{index + 1}</h6>
//                       <Button
//                         variant="outline-danger"
//                         size="sm"
//                         onClick={() => removeProductRow(index)}
//                         className="px-2 py-1"
//                       >
//                         ×
//                       </Button>
//                     </div>

//                     <Row className="g-3">
//                       <Col md={12}>
//                         <Form.Group>
//                           <Form.Label className="small fw-semibold">Product</Form.Label>
//                           <Form.Select
//                             value={product.product_id}
//                             onChange={(e) => handleProductChange(index, "product_id", e.target.value)}
//                             required
//                             className="form-control-sm"
//                           >
//                             <option value="">Select Product</option>
//                             {products.map((prod) => (
//                               <option key={prod.id} value={prod.id}>
//                                 {prod.product_name}
//                               </option>
//                             ))}
//                           </Form.Select>
//                         </Form.Group>
//                       </Col>
//                       <Col md={12}>
//                         <Form.Group>
//                           <Form.Label className="small fw-semibold">License Model</Form.Label>
//                           <Form.Select
//                             value={product.license_model}
//                             onChange={(e) => handleProductChange(index, "license_model", e.target.value)}
//                             required
//                             className="form-control-sm"
//                           >
//                             <option value="subscription">Subscription</option>
//                             <option value="perpetual">Perpetual</option>
//                             <option value="hybrid">Hybrid</option>
//                           </Form.Select>
//                         </Form.Group>
//                       </Col>
//                       <Col md={4}>
//                         <Form.Group>
//                           <Form.Label className="small fw-semibold">Price</Form.Label>
//                           <Form.Control
//                             type="number"
//                             value={product.price}
//                             onChange={(e) => handleProductChange(index, "price", e.target.value)}
//                             required
//                             className="form-control-sm"
//                             min="0"
//                             step="0.01"
//                           />
//                         </Form.Group>
//                       </Col>

//                       <Col md={4}>
//                         <Form.Group>
//                           <Form.Label className="small fw-semibold">Quantity</Form.Label>
//                           <Form.Control
//                             type="number"
//                             value={product.quantity}
//                             onChange={(e) => handleProductChange(index, "quantity", e.target.value)}
//                             required
//                             className="form-control-sm"
//                             min="1"
//                           />
//                         </Form.Group>
//                       </Col>

//                       <Col md={4}>
//                         <Form.Group>
//                           <Form.Label className="small fw-semibold">Total</Form.Label>
//                           <Form.Control
//                             type="text"
//                             value={(product.price * product.quantity).toFixed(2)}
//                             readOnly
//                             className="form-control-sm bg-white fw-bold text-primary"
//                             plaintext
//                           />
//                         </Form.Group>
//                       </Col>

//                       {/* Revenue Type Specific Fields */}
//                       {product.revenue_type === "deferred" ? (
//                         <>
//                           <Col md={6}>
//                             <Form.Group>
//                               <Form.Label className="small fw-semibold">Subscription Start</Form.Label>
//                               <Form.Control
//                                 type="date"
//                                 name="subscription_start_date"
//                                 value={formData.subscription_start_date}
//                                 onChange={handleInputChange}
//                                 className="form-control-sm"
//                               />
//                             </Form.Group>
//                           </Col>

//                           <Col md={6}>
//                             <Form.Group>
//                               <Form.Label className="small fw-semibold">Subscription End</Form.Label>
//                               <Form.Control
//                                 type="date"
//                                 name="vendor_subscription_end_dates"
//                                 value={formData.vendor_subscription_end_dates}
//                                 onChange={handleInputChange}
//                                 className="form-control-sm"
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={6}>
//                             <Form.Group>
//                               <Form.Label className="small fw-semibold">Subscription Due</Form.Label>
//                               <Form.Control
//                                 type="date"
//                                 name="subscription_due_date"
//                                 value={formData.subscription_due_date}
//                                 onChange={handleInputChange}
//                                 className="form-control-sm"
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={6}>
//                             <Form.Group>
//                               <Form.Label className="small fw-semibold">Payment Term</Form.Label>
//                               <Form.Select
//                                 name="payment_term"
//                                 value={formData.payment_term}
//                                 onChange={handleInputChange}
//                                 className="form-control-sm"
//                               >
//                                 <option value="">Select Term</option>
//                                 <option value="custom">Monthly</option>
//                                 <option value="half-yearly">Half-Yearly</option>
//                                 <option value="quarterly">Quarterly</option>
//                                 <option value="yearly">Yearly</option>

//                               </Form.Select>
//                             </Form.Group>
//                           </Col>
//                         </>
//                       ) : (
//                         <>
//                           <Col md={6}>
//                             <Form.Group>
//                               <Form.Label className="small fw-semibold">Deployment Start</Form.Label>
//                               <Form.Control
//                                 type="date"
//                                 name="deployment_start_date"
//                                 value={formData.deployment_start_date}
//                                 onChange={handleInputChange}
//                                 className="form-control-sm"
//                               />
//                             </Form.Group>
//                           </Col>
//                           <Col md={6}>
//                             <Form.Group>
//                               <Form.Label className="small fw-semibold">Deployment End</Form.Label>
//                               <Form.Control
//                                 type="date"
//                                 name="deployment_end_date"
//                                 value={formData.deployment_end_date}
//                                 onChange={handleInputChange}
//                                 className="form-control-sm"
//                               />
//                             </Form.Group>
//                           </Col>
//                         </>
//                       )}
//                     </Row>
//                   </div>
//                 ))
//               )}
//             </Card.Body>
//           </Card>

//           {/* Action Buttons */}
//           <div className="d-flex justify-content-end gap-2 pt-3 border-top">
//             <Button
//               variant="outline-secondary"
//               onClick={handleClose}
//               size="sm"
//               className="px-4"
//             >
//               Cancel
//             </Button>
//             <Button
//               type="submit"
//               variant="primary"
//               size="sm"
//               className="px-4"
//               disabled={formData.products.length === 0}
//             >
//               Create Order
//             </Button>
//           </div>
//         </Form>
//       </Offcanvas.Body>

//       <style jsx>{`
//         .product-card {
//           background: #f8f9fa;
//           border: 1px solid #e9ecef !important;
//         }

//         .form-control-sm {
//           font-size: 0.875rem;
//         }

//         .card {
//           border-radius: 8px;
//         }

//         .btn-sm {
//           font-size: 0.8rem;
//         }
//       `}</style>
//     </Offcanvas>
//   );
// };

// export default DirectOrderForm;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { Offcanvas, Form, Button, Row, Col, Card, Table } from "react-bootstrap";

// const DirectOrderForm = ({ showModal, handleClose, fetchOrders }) => {
//   const [clients, setClients] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [exchangeRates, setExchangeRates] = useState({});
//   const [currentStep, setCurrentStep] = useState(1);
//   const [formData, setFormData] = useState({
//     name: "",
//     client_id: "",
//     project_id: "",
//     products: [],
//     service_products: [],
//     stage: "order",
//     is_direct_order: true,
//     subscription_start_date: "",
//     subscription_due_date: "",
//     vendor_subscription_end_dates: "",
//     payment_term: "",
//     deployment_start_date: "",
//     deployment_end_date: "",
//     order_date: new Date().toISOString().split("T")[0],
//     brand: "",
//     license_model: "",
//     model_type: "new",
//   });

//   useEffect(() => {
//     if (formData.vendor_subscription_end_dates) {
//       const endDate = new Date(formData.vendor_subscription_end_dates);
//       const dueDate = new Date(endDate);
//       dueDate.setDate(endDate.getDate() - 30);
//       const formattedDueDate = dueDate.toISOString().split("T")[0];
//       setFormData((prev) => ({
//         ...prev,
//         subscription_due_date: formattedDueDate,
//       }));
//     }
//   }, [formData.vendor_subscription_end_dates]);

//   // Fetch exchange rates
//   const fetchExchangeRates = async () => {
//     try {
//       const rates = {
//         USD: 1,
//         AED: 3.67,
//         EUR: 0.85,
//         INR: 83.0,
//       };
//       setExchangeRates(rates);
//     } catch (error) {
//       console.error("Error fetching exchange rates:", error);
//     }
//   };

//   const fetchClients = async () => {
//     try {
//       const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//       const origin = localStorage.getItem("user-origin");
//       const res = await axios.get(
//         `${process.env.REACT_APP_BACKEND_URL}/api/contacts?type=client`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Tenant-Origin": origin
//           },
//           skipLoader: true
//         }
//       );
//       setClients(res.data.Data);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const fetchProducts = async () => {
//     try {
//       const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//       const origin = localStorage.getItem("user-origin");
//       const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/products`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Tenant-Origin": origin
//         },
//         skipLoader: true
//       });
//       setProducts(res.data.Data);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (showModal) {
//       setFormData({
//         name: "",
//         client_id: "",
//         project_id: "",
//         products: [],
//         service_products: [],
//         stage: "order",
//         is_direct_order: true,
//         subscription_start_date: "",
//         subscription_due_date: "",
//         vendor_subscription_end_dates: "",
//         payment_term: "",
//         deployment_start_date: "",
//         deployment_end_date: "",
//         order_date: new Date().toISOString().split("T")[0],
//         brand: "",
//         license_model: "",
//         model_type: "new",
//       });
//       setCurrentStep(1);
//       fetchClients();
//       fetchProducts();
//       fetchExchangeRates();
//     }
//   }, [showModal]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));

//     // Reset products when brand or license model changes
//     if (name === "brand" || name === "license_model") {
//       setFormData(prev => ({
//         ...prev,
//         products: [],
//         service_products: []
//       }));
//     }

//     // Auto-add default products when model type changes to "new"
//     if (name === "model_type" && value === "new") {
//       autoAddDefaultProducts();
//     }
//   };

//   // Get client currency
//   const getClientCurrency = () => {
//     const selectedClient = clients.find(client => client.id === parseInt(formData.client_id));
//     return selectedClient?.currency || 'USD';
//   };

//   // Convert price based on currencies
//   const convertPrice = (price, fromCurrency, toCurrency) => {
//     if (!price || !fromCurrency || !toCurrency || fromCurrency === toCurrency) {
//       return parseFloat(price) || 0;
//     }

//     const rateFrom = exchangeRates[fromCurrency] || 1;
//     const rateTo = exchangeRates[toCurrency] || 1;

//     const usdAmount = parseFloat(price) / rateFrom;
//     return usdAmount * rateTo;
//   };

//   // Get product currency
//   const getProductCurrency = (product) => {
//     if (product.vendor && product.vendor.currency) {
//       return product.vendor.currency;
//     }
//     return product.currency || 'USD';
//   };

//   // Get available brands
//   const getAvailableBrands = () => {
//     if (!products || products.length === 0) {
//       return [];
//     }

//     const uniqueBrands = new Set();
//     products.forEach(product => {
//       if (product.brand?.name) {
//         uniqueBrands.add(product.brand.name);
//       }
//     });

//     return Array.from(uniqueBrands);
//   };

//   // Get available license models for selected brand
//   const getAvailableLicenseModels = () => {
//     if (!formData.brand) return [];

//     const uniqueModels = new Set();

//     products.forEach(product => {
//       if (product.brand?.name === formData.brand) {
//         product.pricings?.forEach(pricing => {
//           if (pricing.license_model) {
//             uniqueModels.add(pricing.license_model);
//           }
//         });
//       }
//     });

//     return [...uniqueModels];
//   };

//   // Get license products for selected brand and license model
//   const getLicenseProducts = () => {
//     const filteredProducts = products.filter(product => {
//       const hasBrand = product.brand?.name === formData.brand;
//       const hasLicenseType = product.license_type === "license";
//       const hasPricing = product.pricings?.some(
//         pricing => pricing.license_model === formData.license_model
//       );

//       return hasBrand && hasLicenseType && hasPricing;
//     });

//     console.log(`Found ${filteredProducts.length} license products for brand "${formData.brand}" and license model "${formData.license_model}"`);

//     return filteredProducts;
//   };

//   // Get service products for selected brand
//   const getServiceProducts = () => {
//     if (!formData.brand) {
//       return [];
//     }

//     return products.filter(product => 
//       product.brand?.name === formData.brand &&
//       product.license_type === "service"
//     );
//   };

//   // Get pricing for specific license model and product
//   const getPricingForLicenseModel = (product, licenseModel) => {
//     if (!product || !product.pricings) return null;

//     return product.pricings.find(p => p.license_model === licenseModel) || null;
//   };

//   // Auto-add default products when model type is "new"
//   const autoAddDefaultProducts = () => {
//     if (!formData.brand || !formData.license_model) return;

//     const clientCurrency = getClientCurrency();
//     const licenseProducts = getLicenseProducts();
//     const serviceProducts = getServiceProducts();

//     console.log("Available license products:", licenseProducts.length);
//     console.log("Available service products:", serviceProducts.length);

//     // For "new" model type, add ALL license products, not just default channel
//     const licenseProductsToAdd = formData.model_type === "new" 
//       ? licenseProducts // Add ALL license products for "new"
//       : licenseProducts.filter(product => {
//           // For "expand", only add default channel products
//           return product.pricings?.some(pricing => 
//             pricing.license_model === formData.license_model && 
//             pricing.is_default_channel === true
//           );
//         });

//     console.log("License products to add:", licenseProductsToAdd.length);

//     const newLicenseProducts = licenseProductsToAdd.map(product => {
//       const selectedPricing = getPricingForLicenseModel(product, formData.license_model);
//       const productCurrency = getProductCurrency(product);

//       let price = selectedPricing ? parseFloat(selectedPricing.price) : 0;
//       let deploymentCost = selectedPricing ? parseFloat(selectedPricing.deployment_cost) : 0;

//       if (productCurrency !== clientCurrency) {
//         price = convertPrice(price, productCurrency, clientCurrency);
//         deploymentCost = convertPrice(deploymentCost, productCurrency, clientCurrency);
//       }

//       return {
//         product_id: product.id,
//         item_name: product.product_name || "",
//         revenue_type: product.revenue_type || "deferred",
//         price: price,
//         deployment_cost: deploymentCost,
//         quantity: 1,
//         total_price: price * 1,
//         total_deployment_cost: deploymentCost,
//         license_model: formData.license_model,
//         original_currency: productCurrency,
//         display_currency: clientCurrency,
//         is_auto_added: true,
//       };
//     });

//     // Auto-add service products for "new" model type only
//     const newServiceProducts = formData.model_type === "new" ? serviceProducts.map(product => {
//       const productCurrency = getProductCurrency(product);
//       let price = parseFloat(product.price) || 0;

//       if (productCurrency !== clientCurrency) {
//         price = convertPrice(price, productCurrency, clientCurrency);
//       }

//       return {
//         product_id: product.id,
//         item_name: product.product_name || "",
//         revenue_type: "immediate",
//         price: price,
//         deployment_cost: 0,
//         quantity: 1,
//         total_price: price * 1,
//         total_deployment_cost: 0,
//         license_model: "service",
//         original_currency: productCurrency,
//         display_currency: clientCurrency,
//         is_auto_added: true,
//       };
//     }) : [];

//     setFormData(prev => ({
//       ...prev,
//       products: newLicenseProducts,
//       service_products: newServiceProducts
//     }));

//     if (newLicenseProducts.length > 0 || newServiceProducts.length > 0) {
//       Swal.fire({
//         toast: true,
//         position: 'top-end',
//         icon: 'success',
//         title: `Auto-added ${newLicenseProducts.length} license product(s) and ${newServiceProducts.length} service product(s)`,
//         timer: 3000,
//         showConfirmButton: false
//       });
//     }
//   };

//   // Handle product quantity change
//   const handleProductQuantityChange = (index, value, isService = false) => {
//     const productKey = isService ? "service_products" : "products";
//     const newProducts = [...formData[productKey]];
//     newProducts[index].quantity = parseInt(value) || 1;
//     newProducts[index].total_price = newProducts[index].price * newProducts[index].quantity;

//     setFormData(prev => ({
//       ...prev,
//       [productKey]: newProducts
//     }));
//   };

//   // Remove product row
//   const removeProductRow = (index) => {
//     const newProducts = [...formData.products];
//     newProducts.splice(index, 1);
//     setFormData(prev => ({
//       ...prev,
//       products: newProducts
//     }));
//   };

//   // Calculate totals for display
//   const calculateTotals = () => {
//     const licenseTotals = formData.products.reduce(
//       (acc, product) => {
//         const price = parseFloat(product.price) || 0;
//         const deploymentCost = parseFloat(product.deployment_cost) || 0;
//         const quantity = parseInt(product.quantity) || 1;

//         acc.totalLicensePrice += price * quantity;
//         acc.totalDeployment += deploymentCost;
//         return acc;
//       },
//       { totalLicensePrice: 0, totalDeployment: 0 }
//     );

//     const serviceTotals = formData.service_products.reduce(
//       (acc, product) => {
//         const price = parseFloat(product.price) || 0;
//         const quantity = parseInt(product.quantity) || 1;

//         acc.totalServicePrice += price * quantity;
//         return acc;
//       },
//       { totalServicePrice: 0 }
//     );

//     const grandTotal = licenseTotals.totalLicensePrice + licenseTotals.totalDeployment + serviceTotals.totalServicePrice;

//     return {
//       ...licenseTotals,
//       ...serviceTotals,
//       grandTotal
//     };
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//       const origin = localStorage.getItem("user-origin");

//       // Combine license and service products for submission
//       const allProducts = [...formData.products, ...formData.service_products];

//       const payload = {
//         ...formData,
//         products: allProducts.map((p) => ({
//           ...p,
//           price: parseFloat(p.price) || 0,
//           deployment_cost: parseFloat(p.deployment_cost) || 0,
//           quantity: parseInt(p.quantity) || 1,
//           display_currency: getClientCurrency(),
//         })),
//       };

//       await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/deals/order`, payload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Tenant-Origin": origin
//         },
//       });

//       Swal.fire("Success", "Direct order created successfully", "success");
//       fetchOrders();
//       handleClose();
//     } catch (error) {
//       console.error(error);
//       Swal.fire("Error", "Failed to create direct order", "error");
//     }
//   };

//   const totals = calculateTotals();
//   const clientCurrency = getClientCurrency();
//   const availableBrands = getAvailableBrands();
//   const availableLicenseModels = getAvailableLicenseModels();
//   const licenseProducts = getLicenseProducts();
//   const serviceProducts = getServiceProducts();

//   const nextStep = () => {
//     if (currentStep === 1 && (!formData.brand || !formData.license_model)) {
//       Swal.fire("Warning", "Please select brand and license model", "warning");
//       return;
//     }
//     if (currentStep === 2 && formData.products.length === 0) {
//       Swal.fire("Warning", "Please add at least one product", "warning");
//       return;
//     }
//     setCurrentStep(prev => prev + 1);
//   };

//   const prevStep = () => {
//     setCurrentStep(prev => prev - 1);
//   };

//   // Step 1: Brand and License Selection
//   const renderStep1 = () => (
//     <Card className="mb-4 border-0 shadow-sm">
//       <Card.Header className="bg-white border-bottom-0 pb-2">
//         <h6 className="mb-0 fw-bold text-primary">Step 1: Brand & License Selection</h6>
//       </Card.Header>
//       <Card.Body>
//         <Row className="g-3">
//           <Col md={12}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">Brand</Form.Label>
//               <Form.Select
//                 name="brand"
//                 value={formData.brand}
//                 onChange={handleInputChange}
//                 required
//                 className="form-control form-feild"
//               >
//                 <option value="">Select Brand</option>
//                 {availableBrands.map((brand) => (
//                   <option key={brand} value={brand}>
//                     {brand}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Form.Group>
//           </Col>

//           <Col md={12}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">License Model</Form.Label>
//               <Form.Select
//                 name="license_model"
//                 value={formData.license_model}
//                 onChange={handleInputChange}
//                 required
//                 className="form-control form-feild"
//               >
//                 <option value="">Select License Model</option>
//                 {availableLicenseModels.map((model) => (
//                   <option key={model} value={model}>
//                     {model.charAt(0).toUpperCase() + model.slice(1)}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Form.Group>
//           </Col>

//           {formData.license_model && (
//             <Col md={12}>
//               <Form.Group>
//                 <Form.Label className="fw-semibold small">Model Type</Form.Label>
//                 <Form.Select
//                   name="model_type"
//                   value={formData.model_type}
//                   onChange={handleInputChange}
//                   required
//                   className="form-control form-feild"
//                 >
//                   <option value="new">New</option>
//                   <option value="expand">Expand</option>
//                 </Form.Select>
//                 <Form.Text className="text-muted">
//                   {formData.model_type === "new" 
//                     ? "Auto-adds default channel products and service products" 
//                     : "Manually select products to expand"}
//                 </Form.Text>
//               </Form.Group>
//             </Col>
//           )}
//         </Row>
//       </Card.Body>
//     </Card>
//   );

//   // Step 2: Product Selection (License Products)
//   const renderStep2 = () => {
//     const allLicenseProducts = getLicenseProducts();
//     const currentProductIds = formData.products.map(p => p.product_id);

//     // Products not yet added
//     const availableProducts = allLicenseProducts.filter(
//       product => !currentProductIds.includes(product.id)
//     );

//     return (
//       <Card className="mb-4 border-0 shadow-sm">
//         <Card.Header className="bg-white border-bottom-0 pb-2">
//           <h6 className="mb-0 fw-bold text-primary">
//             Step 2: License Products Selection
//             <small className="text-muted ms-2">
//               ({allLicenseProducts.length} license products available)
//             </small>
//           </h6>
//         </Card.Header>
//         <Card.Body>
//           {/* Show currently selected products */}
//           {formData.products.length > 0 && (
//             <>
//               <h6 className="fw-bold mb-3">Selected Products</h6>
//               <Table striped bordered hover className="mb-4">
//                 <thead>
//                   <tr>
//                     <th>Product Name</th>
//                     <th>Price ({clientCurrency})</th>
//                     <th>Deployment Cost ({clientCurrency})</th>
//                     <th>Quantity</th>
//                     <th>Total ({clientCurrency})</th>
//                     {formData.model_type === "expand" && <th>Action</th>}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {formData.products.map((product, index) => (
//                     <tr key={index}>
//                       <td>
//                         {product.item_name}
//                         {product.is_auto_added && (
//                           <small className="text-success ms-2">(Auto-added)</small>
//                         )}
//                       </td>
//                       <td>{product.price.toFixed(2)}</td>
//                       <td>{product.deployment_cost.toFixed(2)}</td>
//                       <td>
//                         <Form.Control
//                           type="number"
//                           value={product.quantity}
//                           onChange={(e) => handleProductQuantityChange(index, e.target.value)}
//                           min="1"
//                           style={{ width: '80px' }}
//                         />
//                       </td>
//                       <td className="fw-bold">{(product.price * product.quantity).toFixed(2)}</td>
//                       {formData.model_type === "expand" && (
//                         <td>
//                           <Button
//                             variant="outline-danger"
//                             size="sm"
//                             onClick={() => removeProductRow(index)}
//                           >
//                             Remove
//                           </Button>
//                         </td>
//                       )}
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </>
//           )}

//           {/* Show available products for "expand" mode */}
//           {formData.model_type === "expand" && availableProducts.length > 0 && (
//             <>
//               <h6 className="fw-bold mb-3">Available Products</h6>
//               <Table striped bordered hover>
//                 <thead>
//                   <tr>
//                     <th>Product Name</th>
//                     <th>Price ({clientCurrency})</th>
//                     <th>Deployment Cost ({clientCurrency})</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {availableProducts.map((product) => (
//                     <tr key={product.id}>
//                       <td>{product.product_name}</td>
//                       <td>
//                         {(() => {
//                           const pricing = getPricingForLicenseModel(product, formData.license_model);
//                           const productCurrency = getProductCurrency(product);
//                           let price = pricing ? parseFloat(pricing.price) : 0;
//                           if (productCurrency !== clientCurrency) {
//                             price = convertPrice(price, productCurrency, clientCurrency);
//                           }
//                           return price.toFixed(2);
//                         })()}
//                       </td>
//                       <td>
//                         {(() => {
//                           const pricing = getPricingForLicenseModel(product, formData.license_model);
//                           const productCurrency = getProductCurrency(product);
//                           let deploymentCost = pricing ? parseFloat(pricing.deployment_cost) : 0;
//                           if (productCurrency !== clientCurrency) {
//                             deploymentCost = convertPrice(deploymentCost, productCurrency, clientCurrency);
//                           }
//                           return deploymentCost.toFixed(2);
//                         })()}
//                       </td>
//                       <td>
//                         <Button
//                           variant="outline-primary"
//                           size="sm"
//                           onClick={() => {
//                             const productCurrency = getProductCurrency(product);
//                             const pricing = getPricingForLicenseModel(product, formData.license_model);

//                             let price = pricing ? parseFloat(pricing.price) : 0;
//                             let deploymentCost = pricing ? parseFloat(pricing.deployment_cost) : 0;

//                             if (productCurrency !== clientCurrency) {
//                               price = convertPrice(price, productCurrency, clientCurrency);
//                               deploymentCost = convertPrice(deploymentCost, productCurrency, clientCurrency);
//                             }

//                             const newProduct = {
//                               product_id: product.id,
//                               item_name: product.product_name || "",
//                               revenue_type: product.revenue_type || "deferred",
//                               price: price,
//                               deployment_cost: deploymentCost,
//                               quantity: 1,
//                               total_price: price * 1,
//                               total_deployment_cost: deploymentCost,
//                               license_model: formData.license_model,
//                               original_currency: productCurrency,
//                               display_currency: clientCurrency,
//                               is_auto_added: false,
//                             };

//                             setFormData(prev => ({
//                               ...prev,
//                               products: [...prev.products, newProduct]
//                             }));
//                           }}
//                         >
//                           Add
//                         </Button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </>
//           )}

//           {formData.products.length === 0 && formData.model_type === "new" && (
//             <div className="text-center py-4 text-muted">
//               <p>No license products found for the selected criteria</p>
//               <small>Please check your brand and license model selection</small>
//             </div>
//           )}

//           {formData.products.length === 0 && formData.model_type === "expand" && (
//             <div className="text-center py-4 text-muted">
//               <p>No products selected yet</p>
//               <small>Use the "Add" button to select products from the available list</small>
//             </div>
//           )}
//         </Card.Body>
//       </Card>
//     );
//   };

//   // Step 3: Service Products and Deployment Costs
//   const renderStep3 = () => (
//     <Card className="mb-4 border-0 shadow-sm">
//       <Card.Header className="bg-white border-bottom-0 pb-2">
//         <h6 className="mb-0 fw-bold text-primary">Step 3: Service Products & Deployment</h6>
//       </Card.Header>
//       <Card.Body>
//         {/* Service Products Table (only for "new" model type) */}
//         {formData.model_type === "new" && formData.service_products.length > 0 && (
//           <>
//             <h6 className="fw-bold mb-3">Service Products</h6>
//             <Table striped bordered hover className="mb-4">
//               <thead>
//                 <tr>
//                   <th>Service Product Name</th>
//                   <th>Price ({clientCurrency})</th>
//                   <th>Quantity</th>
//                   <th>Total ({clientCurrency})</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {formData.service_products.map((product, index) => (
//                   <tr key={index}>
//                     <td>
//                       {product.item_name}
//                       <small className="text-success ms-2">(Auto-added)</small>
//                     </td>
//                     <td>{product.price.toFixed(2)}</td>
//                     <td>
//                       <Form.Control
//                         type="number"
//                         value={product.quantity}
//                         onChange={(e) => handleProductQuantityChange(index, e.target.value, true)}
//                         min="1"
//                         style={{ width: '80px' }}
//                       />
//                     </td>
//                     <td className="fw-bold">{(product.price * product.quantity).toFixed(2)}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </>
//         )}

//         {/* Deployment Costs Table */}
//         <h6 className="fw-bold mb-3">Deployment Costs</h6>
//         <Table striped bordered hover>
//           <thead>
//             <tr>
//               <th>Product Name</th>
//               <th>Deployment Cost ({clientCurrency})</th>
//             </tr>
//           </thead>
//           <tbody>
//             {formData.products.map((product, index) => (
//               product.deployment_cost > 0 && (
//                 <tr key={index}>
//                   <td>{product.item_name}</td>
//                   <td className="fw-bold text-success">{product.deployment_cost.toFixed(2)}</td>
//                 </tr>
//               )
//             ))}
//           </tbody>
//         </Table>
//       </Card.Body>
//     </Card>
//   );

//   // Step 4: Subscription & Deployment Dates
//   const renderStep4 = () => (
//     <Card className="mb-4 border-0 shadow-sm">
//       <Card.Header className="bg-white border-bottom-0 pb-2">
//         <h6 className="mb-0 fw-bold text-primary">Step 4: Timeline & Payment</h6>
//       </Card.Header>
//       <Card.Body>
//         <Row className="g-3">
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">Subscription Start Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 name="subscription_start_date"
//                 value={formData.subscription_start_date}
//                 onChange={handleInputChange}
//                 className="form-control form-feild"
//               />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">Subscription End Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 name="vendor_subscription_end_dates"
//                 value={formData.vendor_subscription_end_dates}
//                 onChange={handleInputChange}
//                 className="form-control form-feild"
//               />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">Subscription Due Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 name="subscription_due_date"
//                 value={formData.subscription_due_date}
//                 onChange={handleInputChange}
//                 className="form-control form-feild"
//               />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">Payment Term</Form.Label>
//               <Form.Select
//                 name="payment_term"
//                 value={formData.payment_term}
//                 onChange={handleInputChange}
//                 className="form-control form-feild"
//               >
//                 <option value="">Select Term</option>
//                 <option value="monthly">Monthly</option>
//                 <option value="quarterly">Quarterly</option>
//                 <option value="half-yearly">Half-Yearly</option>
//                 <option value="yearly">Yearly</option>
//               </Form.Select>
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">Deployment Start Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 name="deployment_start_date"
//                 value={formData.deployment_start_date}
//                 onChange={handleInputChange}
//                 className="form-control form-feild"
//               />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">Deployment End Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 name="deployment_end_date"
//                 value={formData.deployment_end_date}
//                 onChange={handleInputChange}
//                 className="form-control form-feild"
//               />
//             </Form.Group>
//           </Col>
//         </Row>
//       </Card.Body>
//     </Card>
//   );

//   // Step 5: Final Summary
//   const renderStep5 = () => (
//     <Card className="mb-4 border-0 shadow-sm">
//       <Card.Header className="bg-white border-bottom-0 pb-2">
//         <h6 className="mb-0 fw-bold text-primary">Step 5: Order Summary</h6>
//       </Card.Header>
//       <Card.Body>
//         <Row className="g-3">
//           <Col md={4}>
//             <Card className="text-center border-primary">
//               <Card.Body>
//                 <small className="text-muted">License Products Total</small>
//                 <div className="fw-bold text-primary fs-4">
//                   {totals.totalLicensePrice.toFixed(2)} {clientCurrency}
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>
//           <Col md={4}>
//             <Card className="text-center border-success">
//               <Card.Body>
//                 <small className="text-muted">Deployment Costs</small>
//                 <div className="fw-bold text-success fs-4">
//                   {totals.totalDeployment.toFixed(2)} {clientCurrency}
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>
//           <Col md={4}>
//             <Card className="text-center border-info">
//               <Card.Body>
//                 <small className="text-muted">Service Products Total</small>
//                 <div className="fw-bold text-info fs-4">
//                   {totals.totalServicePrice.toFixed(2)} {clientCurrency}
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>
//           <Col md={12}>
//             <Card className="text-center border-warning mt-3">
//               <Card.Body>
//                 <small className="text-muted">Grand Total</small>
//                 <div className="fw-bold text-dark fs-3">
//                   {totals.grandTotal.toFixed(2)} {clientCurrency}
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>
//       </Card.Body>
//     </Card>
//   );

//   return (
//     <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: "900px" }}>
//       <Offcanvas.Header closeButton className="border-bottom bg-light">
//         <Offcanvas.Title className="fw-bold">Create Direct Order</Offcanvas.Title>
//       </Offcanvas.Header>

//       <Offcanvas.Body className="p-4">
//         {/* Progress Steps */}
//         <div className="steps-progress mb-4">
//           <div className="d-flex justify-content-between">
//             {[1, 2, 3, 4, 5].map(step => (
//               <div key={step} className={`step ${currentStep >= step ? 'active' : ''}`}>
//                 <div className="step-circle">{step}</div>
//                 <div className="step-label">
//                   {step === 1 && 'Brand & License'}
//                   {step === 2 && 'Products'}
//                   {step === 3 && 'Deployment'}
//                   {step === 4 && 'Timeline'}
//                   {step === 5 && 'Summary'}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         <Form onSubmit={handleSubmit}>
//           {/* Basic Information Card - Always visible */}
//           <Card className="mb-4 border-0 shadow-sm">
//             <Card.Header className="bg-white border-bottom-0 pb-2">
//               <h6 className="mb-0 fw-bold text-primary">Order Information</h6>
//             </Card.Header>
//             <Card.Body>
//               <Row className="g-3">
//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Label className="fw-semibold small">Date</Form.Label>
//                     <Form.Control
//                       type="date"
//                       name="order_date"
//                       value={formData.order_date}
//                       onChange={handleInputChange}
//                       required
//                       className="form-control form-feild"
//                     />
//                   </Form.Group>
//                 </Col>
//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Label className="fw-semibold small">Name</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleInputChange}
//                       required
//                       className="form-control form-feild"
//                       placeholder="Enter order name"
//                     />
//                   </Form.Group>
//                 </Col>
//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Label className="fw-semibold small">Client</Form.Label>
//                     <Form.Select
//                       name="client_id"
//                       value={formData.client_id}
//                       onChange={handleInputChange}
//                       required
//                       className="form-control form-feild"
//                     >
//                       <option value="">Select Client</option>
//                       {clients.map((c) => (
//                         <option key={c.id} value={c.id}>
//                           {c.name} {c.currency ? `(${c.currency})` : ''}
//                         </option>
//                       ))}
//                     </Form.Select>
//                   </Form.Group>
//                 </Col>
//               </Row>
//             </Card.Body>
//           </Card>

//           {/* Render current step */}
//           {currentStep === 1 && renderStep1()}
//           {currentStep === 2 && renderStep2()}
//           {currentStep === 3 && renderStep3()}
//           {currentStep === 4 && renderStep4()}
//           {currentStep === 5 && renderStep5()}

//           {/* Navigation Buttons */}
//           <div className="d-flex justify-content-between pt-3 border-top">
//             <div>
//               {currentStep > 1 && (
//                 <Button variant="outline-secondary" onClick={prevStep}>
//                   Previous
//                 </Button>
//               )}
//             </div>
//             <div>
//               {currentStep < 5 ? (
//                 <Button variant="primary" onClick={nextStep}>
//                   Next
//                 </Button>
//               ) : (
//                 <Button 
//                   type="submit" 
//                   variant="success"
//                   disabled={formData.products.length === 0}
//                 >
//                   Create Order
//                 </Button>
//               )}
//             </div>
//           </div>
//         </Form>

//         <style jsx>{`
//           .steps-progress {
//             padding: 20px 0;
//           }
//           .step {
//             text-align: center;
//             flex: 1;
//             position: relative;
//           }
//           .step:not(:last-child)::after {
//             content: '';
//             position: absolute;
//             top: 15px;
//             left: 50%;
//             width: 100%;
//             height: 2px;
//             background: #dee2e6;
//             z-index: 1;
//           }
//           .step.active:not(:last-child)::after {
//             background: #0d6efd;
//           }
//           .step-circle {
//             width: 30px;
//             height: 30px;
//             border-radius: 50%;
//             background: #dee2e6;
//             color: #6c757d;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             margin: 0 auto 5px;
//             position: relative;
//             z-index: 2;
//             font-weight: bold;
//           }
//           .step.active .step-circle {
//             background: #0d6efd;
//             color: white;
//           }
//           .step-label {
//             font-size: 0.8rem;
//             color: #6c757d;
//           }
//           .step.active .step-label {
//             color: #0d6efd;
//             font-weight: bold;
//           }
//         `}</style>
//       </Offcanvas.Body>
//     </Offcanvas>
//   );
// };

// export default DirectOrderForm;




// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { Offcanvas, Form, Button, Row, Col, Card, Table } from "react-bootstrap";

// const DirectOrderForm = ({ showModal, handleClose, fetchOrders }) => {
//   const [clients, setClients] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [exchangeRates, setExchangeRates] = useState({});
//   const [currentStep, setCurrentStep] = useState(1);
//   const [formData, setFormData] = useState({
//     name: "",
//     client_id: "",
//     products: [],
//     stage: "order",
//     is_direct_order: true,
//     subscription_start_date: "",
//     subscription_due_date: "",
//     vendor_subscription_end_dates: "",
//     payment_term: "",
//     deployment_start_date: "",
//     deployment_end_date: "",
//     order_date: new Date().toISOString().split("T")[0],
//     brand: "",
//     license_model: "",
//     model_type: "",
//     subscription_period: 12, // Default 12 months
//   });

//   // Add subscription period to form data
//   useEffect(() => {
//     if (showModal) {
//       setFormData(prev => ({
//         ...prev,
//         subscription_period: 12 // Reset to default when modal opens
//       }));
//     }
//   }, [showModal]);

//   useEffect(() => {
//     if (formData.vendor_subscription_end_dates) {
//       const endDate = new Date(formData.vendor_subscription_end_dates);
//       const dueDate = new Date(endDate);
//       dueDate.setDate(endDate.getDate() - 30);
//       const formattedDueDate = dueDate.toISOString().split("T")[0];
//       setFormData((prev) => ({
//         ...prev,
//         subscription_due_date: formattedDueDate,
//       }));
//     }
//   }, [formData.vendor_subscription_end_dates]);

//   // Fetch exchange rates
//   const fetchExchangeRates = async () => {
//     try {
//       const rates = {
//         USD: 1,
//         AED: 3.67,
//         EUR: 0.85,
//         INR: 83.0,
//       };
//       setExchangeRates(rates);
//     } catch (error) {
//       console.error("Error fetching exchange rates:", error);
//     }
//   };

//   const fetchClients = async () => {
//     try {
//       const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//       const origin = localStorage.getItem("user-origin");
//       const res = await axios.get(
//         `${process.env.REACT_APP_BACKEND_URL}/api/contacts?type=client`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Tenant-Origin": origin
//           },
//           skipLoader: true
//         }
//       );
//       setClients(res.data.Data);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const fetchProducts = async () => {
//     try {
//       const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//       const origin = localStorage.getItem("user-origin");
//       const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/products`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Tenant-Origin": origin
//         },
//         skipLoader: true
//       });
//       setProducts(res.data.Data);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (showModal) {
//       setFormData({
//         name: "",
//         client_id: "",
//         products: [],
//         stage: "order",
//         is_direct_order: true,
//         subscription_start_date: "",
//         subscription_due_date: "",
//         vendor_subscription_end_dates: "",
//         payment_term: "",
//         deployment_start_date: "",
//         deployment_end_date: "",
//         order_date: new Date().toISOString().split("T")[0],
//         brand: "",
//         license_model: "",
//         model_type: " ",
//         subscription_period: 12,
//       });
//       setCurrentStep(1);
//       fetchClients();
//       fetchProducts();
//       fetchExchangeRates();
//     }
//   }, [showModal]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));

//     // Reset products when brand or license model changes
//     if (name === "brand" || name === "license_model") {
//       setFormData(prev => ({
//         ...prev,
//         products: []
//       }));
//     }

//     // Auto-add default products when model type changes to "new"
//     if (name === "model_type" && value === "new") {
//       autoAddDefaultProducts();
//     }
//   };

//   // Get client currency
//   const getClientCurrency = () => {
//     const selectedClient = clients.find(client => client.id === parseInt(formData.client_id));
//     return selectedClient?.currency || 'USD';
//   };

//   // Convert price based on currencies
//   const convertPrice = (price, fromCurrency, toCurrency) => {
//     if (!price || !fromCurrency || !toCurrency || fromCurrency === toCurrency) {
//       return parseFloat(price) || 0;
//     }

//     const rateFrom = exchangeRates[fromCurrency] || 1;
//     const rateTo = exchangeRates[toCurrency] || 1;

//     const usdAmount = parseFloat(price) / rateFrom;
//     return usdAmount * rateTo;
//   };

//   // Get product currency
//   const getProductCurrency = (product) => {
//     if (product.vendor && product.vendor.currency) {
//       return product.vendor.currency;
//     }
//     return product.currency || 'USD';
//   };

//   // Get available brands
//   const getAvailableBrands = () => {
//     if (!products || products.length === 0) {
//       return [];
//     }

//     const uniqueBrands = new Set();
//     products.forEach(product => {
//       if (product.brand?.name) {
//         uniqueBrands.add(product.brand.name);
//       }
//     });

//     return Array.from(uniqueBrands);
//   };

//   // Get available license models for selected brand
//   const getAvailableLicenseModels = () => {
//     if (!formData.brand) return [];

//     const uniqueModels = new Set();

//     products.forEach(product => {
//       if (product.brand?.name === formData.brand) {
//         product.pricings?.forEach(pricing => {
//           if (pricing.license_model) {
//             uniqueModels.add(pricing.license_model);
//           }
//         });
//       }
//     });

//     return [...uniqueModels];
//   };

//   // Get license products for selected brand and license model
//   const getLicenseProducts = () => {
//     const filteredProducts = products.filter(product => {
//       const hasBrand = product.brand?.name === formData.brand;
//       const hasLicenseType = product.license_type === "license";
//       const hasPricing = product.pricings?.some(
//         pricing => pricing.license_model === formData.license_model
//       );

//       return hasBrand && hasLicenseType && hasPricing;
//     });

//     console.log(`Found ${filteredProducts.length} license products for brand "${formData.brand}" and license model "${formData.license_model}"`);

//     return filteredProducts;
//   };

//   // Get service products for selected brand
//   const getServiceProducts = () => {
//     if (!formData.brand) {
//       return [];
//     }

//     return products.filter(product => 
//       product.brand?.name === formData.brand &&
//       product.license_type === "service"
//     );
//   };

//   // Get pricing for specific license model and product
//   const getPricingForLicenseModel = (product, licenseModel) => {
//     if (!product || !product.pricings) return null;

//     return product.pricings.find(p => p.license_model === licenseModel) || null;
//   };

//   // Auto-add default products when model type is "new"
//   const autoAddDefaultProducts = () => {
//     if (!formData.brand || !formData.license_model) return;

//     const clientCurrency = getClientCurrency();
//     const licenseProducts = getLicenseProducts();
//     const serviceProducts = getServiceProducts();

//     console.log("Available license products:", licenseProducts.length);
//     console.log("Available service products:", serviceProducts.length);

//     const newProducts = [];

//     // Add license products with quantity 0
//     licenseProducts.forEach(product => {
//       const selectedPricing = getPricingForLicenseModel(product, formData.license_model);
//       const productCurrency = getProductCurrency(product);

//       let price = selectedPricing ? parseFloat(selectedPricing.price) : 0;
//       let deploymentCost = selectedPricing ? parseFloat(selectedPricing.deployment_cost) : 0;

//       if (productCurrency !== clientCurrency) {
//         price = convertPrice(price, productCurrency, clientCurrency);
//         deploymentCost = convertPrice(deploymentCost, productCurrency, clientCurrency);
//       }

//       newProducts.push({
//         product_id: product.id,
//         item_name: product.product_name || "",
//         revenue_type: "deferred",
//         price: price,
//         deployment_cost: deploymentCost,
//         quantity: 0, // Start with 0
//         total_price: 0,
//         total_deployment_cost: deploymentCost,
//         license_model: formData.license_model,
//         original_currency: productCurrency,
//         display_currency: clientCurrency,
//         is_auto_added: true,
//         product_type: "license"
//       });
//     });

//     // Add service products with quantity 0
//     serviceProducts.forEach(product => {
//       const productCurrency = getProductCurrency(product);
//       let price = parseFloat(product.price) || 0;

//       if (productCurrency !== clientCurrency) {
//         price = convertPrice(price, productCurrency, clientCurrency);
//       }

//       newProducts.push({
//         product_id: product.id,
//         item_name: product.product_name || "",
//         revenue_type: "immediate",
//         price: price,
//         deployment_cost: 0,
//         quantity: 0, // Start with 0
//         total_price: 0,
//         total_deployment_cost: 0,
//         license_model: "service",
//         original_currency: productCurrency,
//         display_currency: clientCurrency,
//         is_auto_added: true,
//         product_type: "service"
//       });
//     });

//     setFormData(prev => ({
//       ...prev,
//       products: newProducts
//     }));

//     if (newProducts.length > 0) {
//       Swal.fire({
//         toast: true,
//         position: 'top-end',
//         icon: 'success',
//         title: `Auto-added ${newProducts.length} products with quantity 0`,
//         timer: 3000,
//         showConfirmButton: false
//       });
//     }
//   };

//   // Handle product quantity change
//   const handleProductQuantityChange = (index, value) => {
//     const newProducts = [...formData.products];
//     const quantity = parseInt(value) || 0;
//     newProducts[index].quantity = quantity;
//     newProducts[index].total_price = newProducts[index].price * quantity;

//     setFormData(prev => ({
//       ...prev,
//       products: newProducts
//     }));
//   };

//   // Remove product row
//   const removeProductRow = (index) => {
//     const newProducts = [...formData.products];
//     newProducts.splice(index, 1);
//     setFormData(prev => ({
//       ...prev,
//       products: newProducts
//     }));
//   };

//   // Calculate totals for display with subscription period
//   const calculateTotals = () => {
//     const subscriptionPeriod = parseInt(formData.subscription_period) || 1;

//     const totals = formData.products.reduce(
//       (acc, product) => {
//         const price = parseFloat(product.price) || 0;
//         const deploymentCost = parseFloat(product.deployment_cost) || 0;
//         const quantity = parseInt(product.quantity) || 0;

//         if (product.revenue_type === 'deferred') {
//           // Subscription products: price * quantity * subscription period
//           acc.totalSubscription += price * quantity * subscriptionPeriod;
//         } else {
//           // Service products: price * quantity (one-time)
//           acc.totalService += price * quantity;
//         }

//         // Deployment cost is always one-time
//         acc.totalDeployment += deploymentCost;

//         return acc;
//       },
//       { 
//         totalSubscription: 0, 
//         totalService: 0, 
//         totalDeployment: 0 
//       }
//     );

//     const grandTotal = totals.totalSubscription + totals.totalService + totals.totalDeployment;

//     return {
//       ...totals,
//       grandTotal,
//       subscriptionPeriod
//     };
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Filter out products with quantity 0
//     const productsToSubmit = formData.products.filter(p => p.quantity > 0);

//     if (productsToSubmit.length === 0) {
//       Swal.fire("Warning", "Please add at least one product with quantity greater than 0", "warning");
//       return;
//     }

//     try {
//       const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//       const origin = localStorage.getItem("user-origin");

//       const payload = {
//         ...formData,
//         products: productsToSubmit.map((p) => ({
//           ...p,
//           price: parseFloat(p.price) || 0,
//           deployment_cost: parseFloat(p.deployment_cost) || 0,
//           quantity: parseInt(p.quantity) || 0,
//           subscription_period: parseInt(formData.subscription_period) || 12,
//         })),
//       };

//       await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/deals/order`, payload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Tenant-Origin": origin
//         },
//       });

//       Swal.fire("Success", "Direct order created successfully", "success");
//       fetchOrders();
//       handleClose();
//     } catch (error) {
//       console.error(error);
//       Swal.fire("Error", "Failed to create direct order", "error");
//     }
//   };

//   const totals = calculateTotals();
//   const clientCurrency = getClientCurrency();
//   const availableBrands = getAvailableBrands();
//   const availableLicenseModels = getAvailableLicenseModels();

//   const nextStep = () => {
//     if (currentStep === 1 && (!formData.brand || !formData.license_model)) {
//       Swal.fire("Warning", "Please select brand and license model", "warning");
//       return;
//     }
//     if (currentStep === 2 && formData.products.filter(p => p.quantity > 0).length === 0) {
//       Swal.fire("Warning", "Please add at least one product with quantity greater than 0", "warning");
//       return;
//     }
//     setCurrentStep(prev => prev + 1);
//   };

//   const prevStep = () => {
//     setCurrentStep(prev => prev - 1);
//   };

//   // Step 1: Brand and License Selection
//   const renderStep1 = () => (
//     <Card className="mb-4 border-0 shadow-sm">
//       <Card.Header className="bg-white border-bottom-0 pb-2">
//         <h6 className="mb-0 fw-bold text-primary">Step 1: Brand & License Selection</h6>
//       </Card.Header>
//       <Card.Body>
//         <Row className="g-3">
//           <Col md={12}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">Brand</Form.Label>
//               <Form.Select
//                 name="brand"
//                 value={formData.brand}
//                 onChange={handleInputChange}
//                 required
//                 className="form-control form-feild"
//               >
//                 <option value="">Select Brand</option>
//                 {availableBrands.map((brand) => (
//                   <option key={brand} value={brand}>
//                     {brand}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Form.Group>
//           </Col>

//           <Col md={12}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">License Model</Form.Label>
//               <Form.Select
//                 name="license_model"
//                 value={formData.license_model}
//                 onChange={handleInputChange}
//                 required
//                 className="form-control form-feild"
//               >
//                 <option value="">Select License Model</option>
//                 {availableLicenseModels.map((model) => (
//                   <option key={model} value={model}>
//                     {model.charAt(0).toUpperCase() + model.slice(1)}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Form.Group>
//           </Col>

//             <Col md={12}>
//               <Form.Group>
//                 <Form.Label className="fw-semibold small">Model Type</Form.Label>
//                 <Form.Select
//                   name="model_type"
//                   value={formData.model_type}
//                   onChange={handleInputChange}
//                   required
//                   className="form-control form-feild"
//                 >
//                   <option value=''>Select</option>

//                   <option value="new">New</option>
//                   <option value="expand">Expand</option>
//                 </Form.Select>

//               </Form.Group>
//             </Col>

//         </Row>
//       </Card.Body>
//     </Card>
//   );

//   // Step 2: Product Selection - Single Table
//   const renderStep2 = () => {
//     const productsWithQuantity = formData.products.filter(p => p.quantity > 0);
//     const productsWithZeroQuantity = formData.products.filter(p => p.quantity === 0);

//     return (
//       <Card className="mb-4 border-0 shadow-sm">
//         <Card.Header className="bg-white border-bottom-0 pb-2">
//           <h6 className="mb-0 fw-bold text-primary">
//             Step 2: Products Selection
//             <small className="text-muted ms-2">
//               ({formData.products.length} products available)
//             </small>
//           </h6>
//         </Card.Header>
//         <Card.Body>
//           {/* Subscription Period Input */}
//           <Row className="mb-4">
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label className="fw-semibold small">Subscription Period (Months)</Form.Label>
//                 <Form.Control
//                   type="number"
//                   name="subscription_period"
//                   value={formData.subscription_period}
//                   onChange={handleInputChange}
//                   min="1"
//                   max="60"
//                   className="form-control form-feild"
//                 />
//                 <Form.Text className="text-muted">
//                   Subscription license products will be multiplied by this period
//                 </Form.Text>
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* Single Table for All Products */}
//           <Table striped bordered hover>
//             <thead className="table-sales-gradient">
//               <tr>
//                 <th>Product Name</th>
//                 <th>Type</th>
//                 <th>Price ({clientCurrency})</th>
//                 <th>Deployment Cost ({clientCurrency})</th>
//                 <th>Quantity</th>
//                 <th>Total ({clientCurrency})</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {/* Products with quantity > 0 - shown first */}
//               {productsWithQuantity.map((product, index) => (
//                 <tr key={`active-${index}`} className="table-success">
//                   <td>
//                     {product.item_name}
//                     {product.is_auto_added && (
//                       <small className="text-success ms-2">(Auto-added)</small>
//                     )}
//                   </td>
//                   <td>
//                     <span className={`badge ${product.revenue_type === 'deferred' ? 'bg-info' : 'bg-warning'}`}>
//                       {product.revenue_type === 'deferred' ? 'Subscription' : 'Service'}
//                     </span>
//                   </td>
//                   <td>{product.price.toFixed(2)}</td>
//                   <td>{product.deployment_cost.toFixed(2)}</td>
//                   <td>
//                     <Form.Control
//                       type="number"
//                       value={product.quantity}
//                       onChange={(e) => handleProductQuantityChange(
//                         formData.products.findIndex(p => p.product_id === product.product_id), 
//                         e.target.value
//                       )}
//                       min="0"
//                       style={{ width: '80px' }}
//                     />
//                   </td>
//                   <td className="fw-bold">
//                     {product.revenue_type === 'deferred' 
//                       ? (product.price * product.quantity * totals.subscriptionPeriod).toFixed(2)
//                       : (product.price * product.quantity).toFixed(2)
//                     }
//                   </td>
//                   <td>
//                     <Button
//                       variant="outline-danger"
//                       size="sm"
//                       onClick={() => removeProductRow(
//                         formData.products.findIndex(p => p.product_id === product.product_id)
//                       )}
//                     >
//                       Remove
//                     </Button>
//                   </td>
//                 </tr>
//               ))}

//               {/* Products with quantity 0 - shown below */}
//               {productsWithZeroQuantity.map((product, index) => (
//                 <tr key={`inactive-${index}`} className="table-sales-gradient">
//                   <td>
//                     {product.item_name}
//                     {product.is_auto_added && (
//                       <small className="text-success ms-2">(Auto-added)</small>
//                     )}
//                   </td>
//                   <td>
//                     <span className={`badge ${product.revenue_type === 'deferred' ? 'bg-info' : 'bg-warning'}`}>
//                       {product.revenue_type === 'deferred' ? 'Subscription' : 'Service'}
//                     </span>
//                   </td>
//                   <td>{product.price.toFixed(2)}</td>
//                   <td>{product.deployment_cost.toFixed(2)}</td>
//                   <td>
//                     <Form.Control
//                       type="number"
//                       value={product.quantity}
//                       onChange={(e) => handleProductQuantityChange(
//                         formData.products.findIndex(p => p.product_id === product.product_id), 
//                         e.target.value
//                       )}
//                       min="0"
//                       style={{ width: '80px' }}
//                     />
//                   </td>
//                   <td>0.00</td>
//                   <td>
//                     <Button
//                       variant="outline-danger"
//                       size="sm"
//                       onClick={() => removeProductRow(
//                         formData.products.findIndex(p => p.product_id === product.product_id)
//                       )}
//                     >
//                       Remove
//                     </Button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>

//           {formData.products.length === 0 && (
//             <div className="text-center py-4 text-muted">
//               <p>No products available</p>
//               <small>Please select a brand and license model first</small>
//             </div>
//           )}
//         </Card.Body>
//       </Card>
//     );
//   };

//   // Step 3: Subscription & Deployment Dates
//   const renderStep3 = () => (
//     <Card className="mb-4 border-0 shadow-sm">
//       <Card.Header className="bg-white border-bottom-0 pb-2">
//         <h6 className="mb-0 fw-bold text-primary">Step 3: Timeline & Payment</h6>
//       </Card.Header>
//       <Card.Body>
//         <Row className="g-3">
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">Subscription Start Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 name="subscription_start_date"
//                 value={formData.subscription_start_date}
//                 onChange={handleInputChange}
//                 className="form-control form-feild"
//               />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">Subscription End Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 name="vendor_subscription_end_dates"
//                 value={formData.vendor_subscription_end_dates}
//                 onChange={handleInputChange}
//                 className="form-control form-feild"
//               />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">Subscription Due Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 name="subscription_due_date"
//                 value={formData.subscription_due_date}
//                 onChange={handleInputChange}
//                 className="form-control form-feild"
//               />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">Payment Term</Form.Label>
//               <Form.Select
//                 name="payment_term"
//                 value={formData.payment_term}
//                 onChange={handleInputChange}
//                 className="form-control form-feild"
//               >
//                 <option value="">Select Term</option>
//                 <option value="monthly">Monthly</option>
//                 <option value="quarterly">Quarterly</option>
//                 <option value="half-yearly">Half-Yearly</option>
//                 <option value="yearly">Yearly</option>
//               </Form.Select>
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">Deployment Start Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 name="deployment_start_date"
//                 value={formData.deployment_start_date}
//                 onChange={handleInputChange}
//                 className="form-control form-feild"
//               />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label className="fw-semibold small">Deployment End Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 name="deployment_end_date"
//                 value={formData.deployment_end_date}
//                 onChange={handleInputChange}
//                 className="form-control form-feild"
//               />
//             </Form.Group>
//           </Col>
//         </Row>
//       </Card.Body>
//     </Card>
//   );

//   // Step 4: Final Summary
//   const renderStep4 = () => (
//     <Card className="mb-4 border-0 shadow-sm">
//       <Card.Header className="bg-white border-bottom-0 pb-2">
//         <h6 className="mb-0 fw-bold text-primary">
//           Step 4: Order Summary 
//           <small className="text-muted ms-2">({totals.subscriptionPeriod} months)</small>
//         </h6>
//       </Card.Header>
//       <Card.Body>
//         <Row className="g-3">
//           <Col md={4}>
//             <Card className="text-center border-primary">
//               <Card.Body>
//                 <small className="text-muted">Subscription Total</small>
//                 <div className="fw-bold text-primary fs-4">
//                   {totals.totalSubscription.toFixed(2)} {clientCurrency}
//                 </div>
//                 <small className="text-muted">
//                   ({totals.subscriptionPeriod} months)
//                 </small>
//               </Card.Body>
//             </Card>
//           </Col>
//           <Col md={4}>
//             <Card className="text-center border-success">
//               <Card.Body>
//                 <small className="text-muted">Service Products</small>
//                 <div className="fw-bold text-success fs-4">
//                   {totals.totalService.toFixed(2)} {clientCurrency}
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>
//           <Col md={4}>
//             <Card className="text-center border-info">
//               <Card.Body>
//                 <small className="text-muted">Deployment Costs</small>
//                 <div className="fw-bold text-info fs-4">
//                   {totals.totalDeployment.toFixed(2)} {clientCurrency}
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>
//           <Col md={12}>
//             <Card className="text-center border-warning mt-3">
//               <Card.Body>
//                 <small className="text-muted">Grand Total</small>
//                 <div className="fw-bold text-dark fs-3">
//                   {totals.grandTotal.toFixed(2)} {clientCurrency}
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>
//       </Card.Body>
//     </Card>
//   );

//   return (
//     <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: "1000px" }}>
//       <Offcanvas.Header closeButton className="border-bottom bg-light">
//         <Offcanvas.Title className="fw-bold">Create Direct Order</Offcanvas.Title>
//       </Offcanvas.Header>

//       <Offcanvas.Body className="p-4">
//         {/* Progress Steps */}
//         <div className="steps-progress mb-4">
//           <div className="d-flex justify-content-between">
//             {[1, 2, 3, 4].map(step => (
//               <div key={step} className={`step ${currentStep >= step ? 'active' : ''}`}>
//                 <div className="step-circle">{step}</div>
//                 <div className="step-label">
//                   {step === 1 && 'Brand & License'}
//                   {step === 2 && 'Products'}
//                   {step === 3 && 'Timeline'}
//                   {step === 4 && 'Summary'}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         <Form onSubmit={handleSubmit}>
//           {/* Basic Information Card - Always visible */}
//           <Card className="mb-4 border-0 shadow-sm">
//             <Card.Header className="bg-white border-bottom-0 pb-2">
//               <h6 className="mb-0 fw-bold text-primary">Order Information</h6>
//             </Card.Header>
//             <Card.Body>
//               <Row className="g-3">
//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Label className="fw-semibold small">Date</Form.Label>
//                     <Form.Control
//                       type="date"
//                       name="order_date"
//                       value={formData.order_date}
//                       onChange={handleInputChange}
//                       required
//                       className="form-control form-feild"
//                     />
//                   </Form.Group>
//                 </Col>
//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Label className="fw-semibold small">Name</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleInputChange}
//                       required
//                       className="form-control form-feild"
//                       placeholder="Enter order name"
//                     />
//                   </Form.Group>
//                 </Col>
//                 <Col md={12}>
//                   <Form.Group>
//                     <Form.Label className="fw-semibold small">Client</Form.Label>
//                     <Form.Select
//                       name="client_id"
//                       value={formData.client_id}
//                       onChange={handleInputChange}
//                       required
//                       className="form-control form-feild"
//                     >
//                       <option value="">Select Client</option>
//                       {clients.map((c) => (
//                         <option key={c.id} value={c.id}>
//                           {c.name} {c.currency ? `(${c.currency})` : ''}
//                         </option>
//                       ))}
//                     </Form.Select>
//                   </Form.Group>
//                 </Col>
//               </Row>
//             </Card.Body>
//           </Card>

//           {/* Render current step */}
//           {currentStep === 1 && renderStep1()}
//           {currentStep === 2 && renderStep2()}
//           {currentStep === 3 && renderStep3()}
//           {currentStep === 4 && renderStep4()}

//           {/* Navigation Buttons */}
//           <div className="d-flex justify-content-between pt-3 border-top">
//             <div>
//               {currentStep > 1 && (
//                 <Button variant="outline-secondary" onClick={prevStep}>
//                   Previous
//                 </Button>
//               )}
//             </div>
//             <div>
//               {currentStep < 4 ? (
//                 <Button variant="primary" onClick={nextStep}>
//                   Next
//                 </Button>
//               ) : (
//                 <Button 
//                   type="submit" 
//                   variant="success"
//                   disabled={formData.products.filter(p => p.quantity > 0).length === 0}
//                 >
//                   Create Order
//                 </Button>
//               )}
//             </div>
//           </div>
//         </Form>

//         <style jsx>{`
//           .steps-progress {
//             padding: 20px 0;
//           }
//           .step {
//             text-align: center;
//             flex: 1;
//             position: relative;
//           }
//           .step:not(:last-child)::after {
//             content: '';
//             position: absolute;
//             top: 15px;
//             left: 50%;
//             width: 100%;
//             height: 2px;
//             background: #dee2e6;
//             z-index: 1;
//           }
//           .step.active:not(:last-child)::after {
//             background: #0d6efd;
//           }
//           .step-circle {
//             width: 30px;
//             height: 30px;
//             border-radius: 50%;
//             background: #dee2e6;
//             color: #6c757d;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             margin: 0 auto 5px;
//             position: relative;
//             z-index: 2;
//             font-weight: bold;
//           }
//           .step.active .step-circle {
//             background: #0d6efd;
//             color: white;
//           }
//           .step-label {
//             font-size: 0.8rem;
//             color: #6c757d;
//           }
//           .step.active .step-label {
//             color: #0d6efd;
//             font-weight: bold;
//           }
//         `}</style>
//       </Offcanvas.Body>
//     </Offcanvas>
//   );
// };

// export default DirectOrderForm;

import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Offcanvas, Form, Button, Row, Col, Card, Table } from "react-bootstrap";

const DirectOrderForm = ({ showModal, handleClose, fetchOrders }) => {
  const [clients, setClients] = useState([]);
  const [products, setProducts] = useState([]);
  const [exchangeRates, setExchangeRates] = useState({});
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    name: "",
    client_id: "",
    products: [],
    stage: "order",
    is_direct_order: true,
    subscription_start_date: "",
    subscription_due_date: "",
    vendor_subscription_end_dates: "",
    payment_term: "",
    deployment_start_date: "",
    deployment_end_date: "",
    order_date: new Date().toISOString().split("T")[0],
    brand: "",
    license_model: "",
    model_type: "",
    subscription_period: 12,
  });

  // Add subscription period to form data
  useEffect(() => {
    if (showModal) {
      setFormData(prev => ({
        ...prev,
        subscription_period: 12
      }));
    }
  }, [showModal]);

  useEffect(() => {
    if (formData.vendor_subscription_end_dates) {
      const endDate = new Date(formData.vendor_subscription_end_dates);
      const dueDate = new Date(endDate);
      dueDate.setDate(endDate.getDate() - 30);
      const formattedDueDate = dueDate.toISOString().split("T")[0];
      setFormData((prev) => ({
        ...prev,
        subscription_due_date: formattedDueDate,
      }));
    }
  }, [formData.vendor_subscription_end_dates]);

  // Fetch exchange rates
  const fetchExchangeRates = async () => {
    try {
      // Prioritize exchange rate from localStorage
      const storedRate = localStorage.getItem('exchange_rate_usd_aed');
      const rate = storedRate ? parseFloat(storedRate) : 3.67;

      const rates = {
        USD: 1,
        AED: rate,
        EUR: 0.85,
        INR: 83.0,
      };
      setExchangeRates(rates);
      console.log("Exchange rates initialized:", rates);
    } catch (error) {
      console.error("Error fetching exchange rates:", error);
    }
  };

  const fetchClients = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("user-info"))?.token;
      const origin = localStorage.getItem("user-origin");
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/contacts?type=client`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Tenant-Origin": origin
          },
          skipLoader: true
        }
      );
      setClients(res.data.Data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchProducts = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("user-info"))?.token;
      const origin = localStorage.getItem("user-origin");
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/products`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Tenant-Origin": origin
        },
        skipLoader: true
      });
      setProducts(res.data.Data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (showModal) {
      setFormData({
        name: "",
        client_id: "",
        products: [],
        stage: "order",
        is_direct_order: true,
        subscription_start_date: "",
        subscription_due_date: "",
        vendor_subscription_end_dates: "",
        payment_term: "",
        deployment_start_date: "",
        deployment_end_date: "",
        order_date: new Date().toISOString().split("T")[0],
        brand: "",
        license_model: "",
        model_type: "",
        subscription_period: 12,
      });
      setCurrentStep(1);
      fetchClients();
      fetchProducts();
      fetchExchangeRates();
    }
  }, [showModal]);

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));

  //   // Reset products when brand or license model changes
  //   if (name === "brand" || name === "license_model") {
  //     setFormData(prev => ({
  //       ...prev,
  //       products: []
  //     }));

  //     return; // prevent model_type autoAdd running in same cycle
  //   }

  //   // Auto-add default products when model type changes to "new"
  //   if (name === "model_type" && value === "new" && formData.brand && formData.license_model) {
  //     autoAddDefaultLicenseProducts();
  //   }

  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updated = { ...prev, [name]: value };

      // If brand or license model changes → clear products and stop here
      if (name === "brand" || name === "license_model") {
        updated.products = [];
        return updated; // ✅ prevents auto-add running in same cycle
      }



      return updated;
    });
  };

  useEffect(() => {
    if (
      formData.model_type && // Both "new" and "expand"
      formData.brand &&
      formData.license_model
    ) {
      autoAddDefaultLicenseProducts();
    }
  }, [formData.model_type, formData.brand, formData.license_model]);

  // Get client currency
  const getClientCurrency = () => {
    const selectedClient = clients.find(client => client.id === parseInt(formData.client_id));
    return selectedClient?.currency || 'USD';
  };
   const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData(prev => ({
      ...prev,
      po_attachment: file
    }));
  };

  // Convert price based on currencies
  const convertPrice = (price, fromCurrency, toCurrency) => {
    if (!price || !fromCurrency || !toCurrency || fromCurrency === toCurrency) {
      return parseFloat(price) || 0;
    }

    const rateFrom = exchangeRates[fromCurrency] || 1;
    const rateTo = exchangeRates[toCurrency] || 1;

    // Normalizing to USD first, then to target currency
    const normalizedToUsd = parseFloat(price) / rateFrom;
    const finalPrice = normalizedToUsd * rateTo;

    console.log(`Currency Conversion: ${price} ${fromCurrency} -> ${finalPrice.toFixed(2)} ${toCurrency} (using rates: ${fromCurrency}=${rateFrom}, ${toCurrency}=${rateTo})`);
    
    return finalPrice;
  };

  const getProductCurrency = (product) => {
    if (product.product_currency) {
      return product.product_currency;
    }
    if (product.currency) {
      return product.currency;
    }
    if (product.vendor && product.vendor.currency) {
      return product.vendor.currency;
    }
    return 'AED'; // Default to AED if not specified
  };

  // Get available brands
  const getAvailableBrands = () => {
    if (!products || products.length === 0) {
      return [];
    }

    const uniqueBrands = new Set();
    products.forEach(product => {
      if (product.brand?.name) {
        uniqueBrands.add(product.brand.name);
      }
    });

    return Array.from(uniqueBrands);
  };

  // Get available license models for selected brand
  const getAvailableLicenseModels = () => {
    if (!formData.brand) return [];

    const uniqueModels = new Set();

    products.forEach(product => {
      if (product.brand?.name === formData.brand) {
        product.pricings?.forEach(pricing => {
          if (pricing.license_model) {
            uniqueModels.add(pricing.license_model);
          }
        });
      }
    });

    return [...uniqueModels];
  };

  // Get license products for selected brand and license model
  const getLicenseProducts = () => {
    const filteredProducts = products.filter(product => {
      const hasBrand = product.brand?.name === formData.brand;
      const hasLicenseType = product.license_type === "license";
      const hasPricing = product.pricings?.some(
        pricing => pricing.license_model === formData.license_model
      );

      return hasBrand && hasLicenseType && hasPricing;
    });

    return filteredProducts;
  };

  // Get service products for selected brand
  const getServiceProducts = () => {
    if (!formData.brand) {
      return [];
    }

    return products.filter(product =>
      product.brand?.name === formData.brand &&
      product.license_type === "service"
    );
  };

  const getPricingForLicenseModel = (product, licenseModel) => {
    if (!product || !product.pricings) return null;

    return product.pricings.find(
      p => String(p.license_model).toLowerCase() === String(licenseModel).toLowerCase()
    ) || null;
  };


  // Auto-add default LICENSE products only when model type is "new"
  // const autoAddDefaultLicenseProducts = () => {
  //   if (!formData.brand || !formData.license_model) return;

  //   const clientCurrency = getClientCurrency();
  //   const licenseProducts = getLicenseProducts();

  //   console.log("Available license products:", licenseProducts.length);
  //   console.log("Model type:", formData.model_type);

  //   const newLicenseProducts = licenseProducts.map(product => {
  //     const selectedPricing = getPricingForLicenseModel(product, formData.license_model);
  //     const productCurrency = getProductCurrency(product);

  //     let price = selectedPricing ? parseFloat(selectedPricing.price) : 0;
  //     let deploymentCost = selectedPricing ? parseFloat(selectedPricing.deployment_cost) : 0;

  //     if (productCurrency !== clientCurrency) {
  //       price = convertPrice(price, productCurrency, clientCurrency);
  //       deploymentCost = convertPrice(deploymentCost, productCurrency, clientCurrency);
  //     }

  //     // Debug logging
  //     console.log("Product:", product.product_name);
  //     console.log("Selected pricing:", selectedPricing);
  //     console.log("Is default channel:", selectedPricing?.is_default_channel);
  //     console.log("Model type:", formData.model_type);

  //     // Determine quantity based on model type and is_default_channel
  //     let quantity = 0;

  //     if (formData.model_type === "new") {
  //       // For "new" model type: default channel products get quantity 1, others get 0
  //       const isDefaultChannel = selectedPricing && 
  //         ["1", 1, true, "true", "yes", "YES"].includes(selectedPricing.is_default_channel);

  //       quantity = isDefaultChannel ? 1 : 0;
  //       console.log("Setting quantity to:", quantity, "because isDefaultChannel:", isDefaultChannel);
  //     } else {
  //       // For "expand" model type: all products get quantity 0
  //       quantity = 0;
  //     }

  //     return {
  //       product_id: product.id,
  //       item_name: product.product_name || "",
  //       license_model: formData.license_model,
  //       price: price,
  //       deployment_cost: deploymentCost,
  //       quantity: quantity,
  //       total_price: price * quantity,
  //       original_currency: productCurrency,
  //       display_currency: clientCurrency,
  //       is_auto_added: true,
  //       license_type: "license",
  //       is_default_channel: selectedPricing?.is_default_channel || false
  //     };
  //   });

  //   console.log("Final products with quantities:", newLicenseProducts.map(p => ({
  //     name: p.item_name,
  //     quantity: p.quantity,
  //     is_default: p.is_default_channel,
  //     price: p.price
  //   })));

  //   setFormData(prev => ({
  //     ...prev,
  //     products: newLicenseProducts
  //   }));

  //   const defaultChannelCount = newLicenseProducts.filter(p => p.quantity === 1).length;
  //   const totalCount = newLicenseProducts.length;

  //   if (newLicenseProducts.length > 0) {
  //     Swal.fire({
  //       toast: true,
  //       position: 'top-end',
  //       icon: 'success',
  //       title: `Auto-added ${totalCount} license products (${defaultChannelCount} default channel with quantity 1)`,
  //       timer: 3000,
  //       showConfirmButton: false
  //     });
  //   }
  // };


  // In autoAddDefaultLicenseProducts function, make sure Deployment is service
  const autoAddDefaultLicenseProducts = () => {
    if (!formData.brand || !formData.license_model) return;

    const clientCurrency = getClientCurrency();
    const licenseProducts = getLicenseProducts();

    const newLicenseProducts = licenseProducts.map(product => {
      const selectedPricing = getPricingForLicenseModel(product, formData.license_model);
      const productCurrency = getProductCurrency(product);

      let price = selectedPricing ? parseFloat(selectedPricing.price) : 0;
      let deploymentCost = selectedPricing ? parseFloat(selectedPricing.deployment_cost) : 0;

      if (productCurrency !== clientCurrency) {
        price = convertPrice(price, productCurrency, clientCurrency);
        deploymentCost = convertPrice(deploymentCost, productCurrency, clientCurrency);
      }

      // Determine quantity based on model type and is_default_channel
      let quantity = 0;

      if (formData.model_type === "new") {
        const isDefaultChannel = selectedPricing &&
          ["1", 1, true, "true", "yes", "YES"].includes(selectedPricing.is_default_channel);
        quantity = isDefaultChannel ? 1 : 0;
      } else {
        quantity = 0;
      }

      return {
        product_id: product.id,
        item_name: product.product_name || "",
        license_model: formData.license_model,
        price: price,
        deployment_cost: deploymentCost,
        quantity: quantity,
        total_price: price * quantity,
        original_currency: productCurrency,
        display_currency: clientCurrency,
        is_auto_added: true,
        license_type: product.license_type || "license", // Use the product's actual license_type
        is_default_channel: selectedPricing?.is_default_channel || false
      };
    });

    setFormData(prev => ({
      ...prev,
      products: newLicenseProducts
    }));
  };
  // Add service products to existing products - Fix price issue
  const addServiceProducts = () => {
    const clientCurrency = getClientCurrency();
    const serviceProducts = getServiceProducts();
    const existingProductIds = formData.products.map(p => p.product_id);

    console.log("Available service products:", serviceProducts.length);
    console.log("Service products data:", serviceProducts);

    const newServiceProducts = serviceProducts
      .filter(product => !existingProductIds.includes(product.id))
      .map(product => {
        const productCurrency = getProductCurrency(product);

        // Get price from product - try multiple possible fields
        let price = 0;

        // Try different price fields
        if (product.price && parseFloat(product.price) > 0) {
          price = parseFloat(product.price);
        } else if (product.unit_price && parseFloat(product.unit_price) > 0) {
          price = parseFloat(product.unit_price);
        } else if (product.cost && parseFloat(product.cost) > 0) {
          price = parseFloat(product.cost);
        } else if (product.pricings && product.pricings.length > 0) {
          // Try to get price from pricings array
          const firstPricing = product.pricings[0];
          if (firstPricing.price && parseFloat(firstPricing.price) > 0) {
            price = parseFloat(firstPricing.price);
          }
        }

        console.log("Service product:", product.product_name, "Price:", price, "Currency:", productCurrency);

        if (productCurrency !== clientCurrency && price > 0) {
          price = convertPrice(price, productCurrency, clientCurrency);
          console.log("Converted price:", price, "to currency:", clientCurrency);
        }

        // For service products, always set quantity to 0 initially
        const quantity = 1;

        return {
          product_id: product.id,
          item_name: product.product_name || "",
          license_model: formData.license_model || "service",
          price: price,
          deployment_cost: 0,
          quantity: quantity,
          total_price: price * quantity,
          original_currency: productCurrency,
          display_currency: clientCurrency,
          is_auto_added: true,
          license_type: "service",
          is_default_channel: product.is_default_channel || false
        };
      });

    console.log("New service products to add:", newServiceProducts);

    if (newServiceProducts.length > 0) {
      setFormData(prev => ({
        ...prev,
        products: [...prev.products, ...newServiceProducts]
      }));

      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: `Added ${newServiceProducts.length} service products`,
        timer: 3000,
        showConfirmButton: false
      });
    }
  };

  // Handle product quantity change
  const handleProductQuantityChange = (index, value) => {
    const newProducts = [...formData.products];
    const quantity = parseInt(value) || 0;
    newProducts[index].quantity = quantity;
    newProducts[index].total_price = newProducts[index].price * quantity;

    setFormData(prev => ({
      ...prev,
      products: newProducts
    }));
  };

  // Remove product row
  const removeProductRow = (index) => {
    const newProducts = [...formData.products];
    newProducts.splice(index, 1);
    setFormData(prev => ({
      ...prev,
      products: newProducts
    }));
  };

  // Calculate totals for display with subscription period
  const calculateTotals = () => {
    const subscriptionPeriod = parseInt(formData.subscription_period) || 1;

    const totals = formData.products.reduce(
      (acc, product) => {
        const price = parseFloat(product.price) || 0;
        const deploymentCost = parseFloat(product.deployment_cost) || 0;
        const quantity = parseInt(product.quantity) || 0;

        // Only calculate for products with quantity > 0 (selected products)
        if (quantity > 0) {
          if (product.license_type === 'license') {
            // License products: price * quantity * subscription period (recurring)
            acc.totalSubscription += price * quantity * subscriptionPeriod;
            // Deployment cost: one-time only for SELECTED products with deployment cost
            if (deploymentCost > 0) {
              acc.totalDeployment += deploymentCost;
            }
          } else if (product.license_type === 'service') {
            // Service products: price * quantity (one-time) - added to deployment total
            acc.totalDeployment += price * quantity;
          }
        }

        return acc;
      },
      {
        totalSubscription: 0,
        totalService: 0,
        totalDeployment: 0
      }
    );

    // Calculate service amount separately for display (only selected products)
    totals.totalService = formData.products
      .filter(p => p.license_type === 'service' && p.quantity > 0)
      .reduce((sum, product) => sum + (product.price * product.quantity), 0);

    const grandTotal = totals.totalSubscription + totals.totalDeployment;

    return {
      ...totals,
      grandTotal,
      subscriptionPeriod
    };
  };
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Filter out products with quantity 0
    const productsToSubmit = formData.products.filter(p => p.quantity > 0);

    if (productsToSubmit.length === 0) {
      Swal.fire("Warning", "Please add at least one product with quantity greater than 0", "warning");
      return;
    }

    try {
      const token = JSON.parse(localStorage.getItem("user-info"))?.token;
      const origin = localStorage.getItem("user-origin");

      const payload = {
        ...formData,
        products: productsToSubmit.map((p) => ({
          ...p,
          price: parseFloat(p.price) || 0,
          deployment_cost: parseFloat(p.deployment_cost) || 0,
          quantity: parseInt(p.quantity) || 0,
          subscription_period: parseInt(formData.subscription_period) || 12,
        })),
      };
      console.log('Payload being sent to backend:', JSON.parse(JSON.stringify(payload)));

      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/deals/order`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Tenant-Origin": origin
        },
      });

      Swal.fire("Success", "Direct order created successfully", "success");
      fetchOrders();
      handleClose();
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to create direct order", "error");
    }
  };

  const totals = calculateTotals();
  const clientCurrency = getClientCurrency();
  const availableBrands = getAvailableBrands();
  const availableLicenseModels = getAvailableLicenseModels();

  const nextStep = () => {
    if (currentStep === 1 && (!formData.brand || !formData.license_model || !formData.model_type)) {
      Swal.fire("Warning", "Please select brand, license model and model type", "warning");
      return;
    }
    if (currentStep === 2 && formData.products.filter(p => p.quantity > 0 && p.license_type === 'license').length === 0) {
      Swal.fire("Warning", "Please add at least one license product with quantity greater than 0", "warning");
      return;
    }

    // When moving from step 2 to step 3, add service products for "new" model type
    if (currentStep === 2 && formData.model_type === "new") {
      addServiceProducts();
    }

    setCurrentStep(prev => prev + 1);
  };

  const prevStep = () => {
    setCurrentStep(prev => prev - 1);
  };

  // Step 1: Brand and License Selection
  const renderStep1 = () => (
    <Card className="mb-4 border-0 shadow-sm">
      <Card.Header className="bg-white border-bottom-0 pb-2">
        <h6 className="mb-0 fw-bold text-primary">Step 1: Brand & License Selection</h6>
      </Card.Header>
      <Card.Body>
        <Row className="g-3">
          <Col md={12}>
            <Form.Group>
              <Form.Label className="fw-semibold small">Brand</Form.Label>
              <Form.Select
                name="brand"
                value={formData.brand}
                onChange={handleInputChange}
                required
                className="form-control form-feild"
              >
                <option value="">Select Brand</option>
                {availableBrands.map((brand) => (
                  <option key={brand} value={brand}>
                    {brand}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group>
              <Form.Label className="fw-semibold small">License Model</Form.Label>
              <Form.Select
                name="license_model"
                value={formData.license_model}
                onChange={handleInputChange}
                required
                className="form-control form-feild"
              >
                <option value="">Select License Model</option>
                {availableLicenseModels.map((model) => (
                  <option key={model} value={model}>
                    {model.charAt(0).toUpperCase() + model.slice(1)}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group>
              <Form.Label className="fw-semibold small">Model Type</Form.Label>
              <Form.Select
                name="model_type"
                value={formData.model_type}
                onChange={handleInputChange}
                required
                className="form-control form-feild"
              >
                <option value=''>Select</option>
                <option value="new">New</option>
                <option value="expand">Expand</option>
              </Form.Select>
             
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );

  // Step 2: License Products Only
  // Step 2: License Products Only - Show only price, quantity, subtotal
  const renderStep2 = () => {
    const licenseProducts = formData.products.filter(p => p.license_type === 'license');

    return (
      <Card className="mb-4 border-0 shadow-sm">
        <Card.Header className="bg-white border-bottom-0 pb-2">
          <h6 className="mb-0 fw-bold text-primary">
            Step 2: License Products Selection
            <small className="text-muted ms-2">
              ({licenseProducts.length} license products available)
            </small>
          </h6>

        </Card.Header>
        <Card.Body>
          {/* Subscription Period Input */}
          <Row className="mb-4">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="fw-semibold small">Subscription Period (Months)</Form.Label>
                <Form.Control
                  type="number"
                  name="subscription_period"
                  value={formData.subscription_period}
                  onChange={handleInputChange}
                  min="1"
                  max="60"
                  className="form-control form-feild"
                />

              </Form.Group>
            </Col>
          </Row>

          {/* All License Products in one table */}
          {licenseProducts.length > 0 && (
            <>
              <Table striped bordered hover>
                <thead className="table-sales-gradient">
                  <tr>
                    <th>Product Name</th>
                    <th>Price ({clientCurrency})</th>
                    <th>Quantity</th>
                    <th>Subtotal ({clientCurrency})</th>
                  </tr>
                </thead>
                <tbody>
                  {licenseProducts.map((product, index) => {
                    const actualIndex = formData.products.findIndex(p => p.product_id === product.product_id);
                    const subtotal = product.price * product.quantity;
                    const isDefaultChannel = product.is_default_channel;

                    return (
                      <tr key={`license-${index}`}
                      >
                        <td>
                          {product.item_name}

                        </td>
                        <td>{product.price.toFixed(2)}</td>
                        <td>
                          <Form.Control
                            type="number"
                            value={product.quantity}
                            onChange={(e) => handleProductQuantityChange(actualIndex, e.target.value)}
                            min="0"
                            style={{ width: '80px' }}
                          />
                        </td>
                        <td className="fw-bold">
                          {subtotal.toFixed(2)}

                        </td>

                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </>
          )}

          {licenseProducts.length === 0 && (
            <div className="text-center py-4 text-muted">
              <p>No license products available</p>
              <small>Please select a brand and license model first</small>
            </div>
          )}

          {/* Step 2 Summary */}
          {licenseProducts.length > 0 && (
            <Card className="mt-4 border-warning">
              <Card.Body className="py-2">
                <Row className="align-items-center">
                  <Col>
                    <small className="text-muted">License Products Subtotal:</small>
                    <div className="fw-bold fs-5">
                      {totals.totalSubscription.toFixed(2)} {clientCurrency}
                      {totals.subscriptionPeriod > 1 && (
                        <small className="text-muted ms-2">
                          (Base: {(totals.totalSubscription / totals.subscriptionPeriod).toFixed(2)} × {totals.subscriptionPeriod} months)
                        </small>
                      )}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}
        </Card.Body>
      </Card>
    );
  };

  // Step 3: Deployment Costs and Service Products
  const renderStep3 = () => {
    // Get selected license products with deployment cost > 0
    const selectedLicenseProducts = formData.products.filter(p =>
      p.license_type === 'license' &&
      p.quantity > 0 &&
      p.deployment_cost > 0
    );

    // Service products with quantity always starting at 0
    const serviceProducts = formData.products.filter(p => p.license_type === 'service');

    return (
      <Card className="mb-4 border-0 shadow-sm">
        <Card.Header className="bg-white border-bottom-0 pb-2">
          <h6 className="mb-0 fw-bold text-primary">
            Step 3: Deployment & Service Products
            <small className="text-muted ms-2">
              ({serviceProducts.length} service products available)
            </small>
          </h6>
        </Card.Header>
        <Card.Body>
          {/* Selected License Products Deployment Costs - Only show if deployment cost > 0 */}
          {selectedLicenseProducts.length > 0 && (
            <>
              <h6 className="fw-bold mb-3">License Products Deployment Costs</h6>
              <Table striped bordered hover className="mb-4">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Deployment Cost ({clientCurrency})</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedLicenseProducts.map((product, index) => (
                    <tr key={`deployment-${index}`}>
                      <td>{product.item_name}</td>
                      <td className="fw-bold text-success">{product.deployment_cost.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}

          {/* Service Products - Quantity always starts at 0 */}
          {serviceProducts.length > 0 && (
            <>
              <h6 className="fw-bold mb-3">Service Products</h6>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Price ({clientCurrency})</th>
                    <th>Quantity</th>
                    <th>Total ({clientCurrency})</th>
                  </tr>
                </thead>
                <tbody>
                  {serviceProducts.map((product, index) => {
                    const actualIndex = formData.products.findIndex(p => p.product_id === product.product_id);

                    return (
                      <tr key={`service-${index}`}>
                        <td>
                          {product.item_name}
                        </td>
                        <td>{product.price.toFixed(2)}</td>
                        <td>
                          <Form.Control
                            type="number"
                            value={product.quantity}
                            onChange={(e) => handleProductQuantityChange(actualIndex, e.target.value)}
                            min="0"
                            style={{ width: '80px' }}
                          />
                        </td>
                        <td className="fw-bold">{(product.price * product.quantity).toFixed(2)}</td>

                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </>
          )}

          {serviceProducts.length === 0 && selectedLicenseProducts.length === 0 && (
            <div className="text-center py-4 text-muted">
              <p>No deployment costs or service products available</p>
            </div>
          )}
        </Card.Body>
      </Card>
    );
  };

  // Step 3: Deployment Costs and Service Products
  // const renderStep3 = () => {
  //   const licenseProducts = formData.products.filter(p => p.license_type === 'license' && p.quantity > 0);
  //   const serviceProducts = formData.products.filter(p => p.license_type === 'service');

  //   return (
  //     <Card className="mb-4 border-0 shadow-sm">
  //       <Card.Header className="bg-white border-bottom-0 pb-2">
  //         <h6 className="mb-0 fw-bold text-primary">
  //           Step 3: Deployment & Service Products
  //           <small className="text-muted ms-2">
  //             ({serviceProducts.length} service products available)
  //           </small>
  //         </h6>
  //       </Card.Header>
  //       <Card.Body>
  //         {/* Selected License Products Deployment Costs */}
  //         {licenseProducts.length > 0 && (
  //           <>
  //             <h6 className="fw-bold mb-3">License Products Deployment Costs</h6>
  //             <Table striped bordered hover className="mb-4">
  //               <thead>
  //                 <tr>
  //                   <th>License Product</th>
  //                   <th>Deployment Cost ({clientCurrency})</th>
  //                 </tr>
  //               </thead>
  //               <tbody>
  //                 {licenseProducts.map((product, index) => (
  //                   product.deployment_cost > 0 && (
  //                     <tr key={`deployment-${index}`}>
  //                       <td>{product.item_name}</td>
  //                       <td className="fw-bold text-success">{product.deployment_cost.toFixed(2)}</td>
  //                     </tr>
  //                   )
  //                 ))}
  //               </tbody>
  //             </Table>
  //           </>
  //         )}

  //         {/* Service Products */}
  //         {serviceProducts.length > 0 && (
  //           <>
  //             <h6 className="fw-bold mb-3">Service Products</h6>
  //             <Table striped bordered hover>
  //               <thead>
  //                 <tr>
  //                   <th>Service Product</th>
  //                   <th>Price ({clientCurrency})</th>
  //                   <th>Quantity</th>
  //                   <th>Total ({clientCurrency})</th>
  //                   <th>Action</th>
  //                 </tr>
  //               </thead>
  //               <tbody>
  //                 {serviceProducts.map((product, index) => (
  //                   <tr key={`service-${index}`}>
  //                     <td>
  //                       {product.item_name}
  //                       <small className="text-success ms-2">(Auto-added)</small>
  //                     </td>
  //                     <td>{product.price.toFixed(2)}</td>
  //                     <td>
  //                       <Form.Control
  //                         type="number"
  //                         value={product.quantity}
  //                         onChange={(e) => handleProductQuantityChange(
  //                           formData.products.findIndex(p => p.product_id === product.product_id), 
  //                           e.target.value
  //                         )}
  //                         min="0"
  //                         style={{ width: '80px' }}
  //                       />
  //                     </td>
  //                     <td className="fw-bold">{(product.price * product.quantity).toFixed(2)}</td>
  //                     <td>
  //                       <Button
  //                         variant="outline-danger"
  //                         size="sm"
  //                         onClick={() => removeProductRow(
  //                           formData.products.findIndex(p => p.product_id === product.product_id)
  //                         )}
  //                       >
  //                         Remove
  //                       </Button>
  //                     </td>
  //                   </tr>
  //                 ))}
  //               </tbody>
  //             </Table>
  //           </>
  //         )}

  //         {serviceProducts.length === 0 && (
  //           <div className="text-center py-4 text-muted">
  //             <p>No service products available</p>
  //           </div>
  //         )}
  //       </Card.Body>
  //     </Card>
  //   );
  // };

  // Step 4: Subscription & Deployment Dates
  const renderStep4 = () => (
    <Card className="mb-4 border-0 shadow-sm">
      <Card.Header className="bg-white border-bottom-0 pb-2">
        <h6 className="mb-0 fw-bold text-primary">Step 4: Timeline & Payment</h6>
      </Card.Header>
      <Card.Body>
        <Row className="g-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold small">Subscription Start Date</Form.Label>
              <Form.Control
                type="date"
                name="subscription_start_date"
                value={formData.subscription_start_date}
                onChange={handleInputChange}
                className="form-control form-feild"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold small">Subscription End Date</Form.Label>
              <Form.Control
                type="date"
                name="vendor_subscription_end_dates"
                value={formData.vendor_subscription_end_dates}
                onChange={handleInputChange}
                className="form-control form-feild"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold small">Subscription Due Date</Form.Label>
              <Form.Control
                type="date"
                name="subscription_due_date"
                value={formData.subscription_due_date}
                onChange={handleInputChange}
                className="form-control form-feild"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold small">Payment Term</Form.Label>
              <Form.Select
                name="payment_term"
                value={formData.payment_term}
                onChange={handleInputChange}
                className="form-control form-feild"
              >
                <option value="">Select Term</option>
                <option value="monthly">Monthly</option>
                <option value="quarterly">Quarterly</option>
                <option value="half-yearly">Half-Yearly</option>
                <option value="yearly">Yearly</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold small">Deployment Start Date</Form.Label>
              <Form.Control
                type="date"
                name="deployment_start_date"
                value={formData.deployment_start_date}
                onChange={handleInputChange}
                className="form-control form-feild"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold small">Deployment End Date</Form.Label>
              <Form.Control
                type="date"
                name="deployment_end_date"
                value={formData.deployment_end_date}
                onChange={handleInputChange}
                className="form-control form-feild"
              />
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
  const renderStep5 = () => (
    <Card className="mb-4 border-0 shadow-sm">
      <Card.Header className="bg-white border-bottom-0 pb-2">
        <h6 className="mb-0 fw-bold text-primary">Step 5: PO Details</h6>
      </Card.Header>
      <Card.Body>
        <Row className="g-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold small">PO Number *</Form.Label>
              <Form.Control
                type="text"
                name="po_number"
                value={formData.po_number}
                onChange={handleInputChange}
                required
                className="form-control form-feild"
                placeholder="Enter PO number"
              />
            </Form.Group>
          </Col>

           <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold small">Issue Date </Form.Label>
              <Form.Control
                type="date"
                name="issue_date"
                value={formData.issue_date}
                onChange={handleInputChange}
                required
                className="form-control form-feild"
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold small">PO Value *</Form.Label>
              <Form.Control
                type="number"
                name="po_value"
                value={formData.po_value}
                onChange={handleInputChange}
                required
                className="form-control form-feild"
                placeholder="Enter PO value without VAT"
                step="0.01"
                min="0"
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label className="fw-semibold small">Total Amount</Form.Label>
              <Form.Control
                type="text"
                name="po_with_vat"
                value={formData.po_with_vat}
                className="form-control form-feild bg-light"
              />
            
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group>
              <Form.Label className="fw-semibold small">PO Attachment</Form.Label>
              <Form.Control
                type="file"
                name="po_attachment"
                onChange={handleFileChange}
                className="form-control form-feild"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              />
            
            </Form.Group>
          </Col>

          {formData.po_attachment && (
            <Col md={12}>
              <div className="alert alert-info py-2">
                <small>
                  <i className="bi bi-file-earmark-text me-2"></i>
                  Selected file: {formData.po_attachment.name}
                </small>
              </div>
            </Col>
          )}
        </Row>
      </Card.Body>
    </Card>
  );

  // Step 6: Final Summary
  const renderStep6 = () => {
    const subscriptionPeriod = parseInt(formData.subscription_period) || 1;

    const recalculatedTotals = formData.products.reduce(
      (acc, product) => {
        const price = parseFloat(product.price) || 0;
        const deploymentCost = parseFloat(product.deployment_cost) || 0;
        const quantity = parseInt(product.quantity) || 0;

        if (quantity > 0) {
          if (product.license_type === 'license') {
            acc.totalSubscription += price * quantity * subscriptionPeriod;
            if (deploymentCost > 0) {
              acc.totalDeployment += deploymentCost;
            }
          } else if (product.license_type === 'service') {
            acc.totalDeployment += price * quantity;
            acc.totalService += price * quantity;
          }
        }

        return acc;
      },
      {
        totalSubscription: 0,
        totalService: 0,
        totalDeployment: 0
      }
    );

    const grandTotal = recalculatedTotals.totalSubscription + recalculatedTotals.totalDeployment;
    const selectedProducts = formData.products.filter(p => p.quantity > 0);

    return (
      <Card className="mb-4 border-0 shadow-sm">
        <Card.Header className="bg-white border-bottom-0 pb-2">
          <h6 className="mb-0 fw-bold text-primary">
            Step 6: Order Summary
            <small className="text-muted ms-2">({subscriptionPeriod} months)</small>
          </h6>
        </Card.Header>
        <Card.Body>
         

          <div className="row g-3 mb-4">
            <div className="col-md-12">
              <div className="border rounded p-3 bg-light">
                <div className="row text-center">
                  <div className="col-md-3 border-end">
                    <div className="text-muted small mb-1">License Subscription</div>
                    <div className="fw-bold text-primary fs-5">
                      {recalculatedTotals.totalSubscription.toFixed(2)} {clientCurrency}
                    </div>
                    <small className="text-muted">({subscriptionPeriod} months)</small>
                  </div>
                  <div className="col-md-3 border-end">
                    <div className="text-muted small mb-1">Service Products</div>
                    <div className="fw-bold text-success fs-5">
                      {recalculatedTotals.totalService.toFixed(2)} {clientCurrency}
                    </div>
                    <small className="text-muted">(One-time)</small>
                  </div>
                  <div className="col-md-3 border-end">
                    <div className="text-muted small mb-1">Deployment & Service</div>
                    <div className="fw-bold text-info fs-5">
                      {recalculatedTotals.totalDeployment.toFixed(2)} {clientCurrency}
                    </div>
                    <small className="text-muted">(One-time)</small>
                  </div>
                  <div className="col-md-3">
                    <div className="text-muted small mb-1">Grand Total</div>
                    <div className="fw-bold text-dark fs-4">
                      {grandTotal.toFixed(2)} {clientCurrency}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        
        </Card.Body>
      </Card>
    );
  };

  return (
    <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: "1000px" }}>
      <Offcanvas.Header closeButton className="border-bottom bg-light">
        <Offcanvas.Title className="fw-bold">Create Direct Order</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-4">
        {/* Progress Steps */}
        <div className="steps-progress mb-4">
          <div className="d-flex justify-content-between">
            {[1, 2, 3, 4, 5, 6].map(step => (
              <div key={step} className={`step ${currentStep >= step ? 'active' : ''}`}>
                <div className="step-circle">{step}</div>
                <div className="step-label">
                  {step === 1 && 'Brand & License'}
                  {step === 2 && 'License Products'}
                  {step === 3 && 'Deployment & Service'}
                  {step === 4 && 'Timeline'}
                  {step === 5 && 'PO Details'}
                  {step === 6 && 'Summary'}
                </div>
              </div>
            ))}
          </div>
        </div>

        <Form onSubmit={handleSubmit}>
          {/* Basic Information Card - Always visible */}
          <Card className="mb-4 border-0 shadow-sm">
            <Card.Header className="bg-white border-bottom-0 pb-2">
              <h6 className="mb-0 fw-bold text-primary">Order Information</h6>
            </Card.Header>
            <Card.Body>
              <Row className="g-3">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label className="fw-semibold small">Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="order_date"
                      value={formData.order_date}
                      onChange={handleInputChange}
                      required
                      className="form-control form-feild"
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label className="fw-semibold small">Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      className="form-control form-feild"
                      placeholder="Enter order name"
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label className="fw-semibold small">Client</Form.Label>
                    <Form.Select
                      name="client_id"
                      value={formData.client_id}
                      onChange={handleInputChange}
                      required
                      className="form-control form-feild"
                    >
                      <option value="">Select Client</option>
                      {clients.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.name} {c.currency ? `(${c.currency})` : ''}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Render current step */}
          {currentStep === 1 && renderStep1()}
          {currentStep === 2 && renderStep2()}
          {currentStep === 3 && renderStep3()}
          {currentStep === 4 && renderStep4()}
          {currentStep === 5 && renderStep5()}
          {currentStep === 6 && renderStep6()}


          {/* Navigation Buttons */}
          <div className="d-flex justify-content-between pt-3 border-top">
            <div>
              {currentStep > 1 && (
                <Button variant="outline-secondary" onClick={prevStep}>
                  Previous
                </Button>
              )}
            </div>
            <div>
              {currentStep < 7 ? (
                <Button variant="primary" onClick={nextStep}>
                  Next
                </Button>
              ) : (
                <Button
                  type="submit"
                  variant="success"
                  disabled={formData.products.filter(p => p.quantity > 0).length === 0}
                >
                  Create Order
                </Button>
              )}
            </div>
          </div>
        </Form>

        <style jsx>{`
          .steps-progress {
            padding: 20px 0;
          }
          .step {
            text-align: center;
            flex: 1;
            position: relative;
          }
          .step:not(:last-child)::after {
            content: '';
            position: absolute;
            top: 15px;
            left: 50%;
            width: 100%;
            height: 2px;
            background: #dee2e6;
            z-index: 1;
          }
          .step.active:not(:last-child)::after {
            background: #0d6efd;
          }
          .step-circle {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background: #dee2e6;
            color: #6c757d;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 5px;
            position: relative;
            z-index: 2;
            font-weight: bold;
          }
          .step.active .step-circle {
            background: #0d6efd;
            color: white;
          }
          .step-label {
            font-size: 0.8rem;
            color: #6c757d;
          }
          .step.active .step-label {
            color: #0d6efd;
            font-weight: bold;
          }
        `}</style>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default DirectOrderForm;


